import {
    AI_BOOK_CATEGORY_FINDER_ROUTE,
    AI_BOOK_DESCRIPTION_GENERATOR_ROUTE,
    AI_BOOK_KEYWORD_GENERATOR_ROUTE,
    AI_BOOK_TITLE_GENERATOR_ROUTE,
    AI_TOOLS_FOR_KDP_ROUTE,
    AMAZON_BSR_CALCULATOR_HOW_TO_USE_ROUTE,
    AMAZON_BSR_CALCULATOR_ROUTE,
    AMAZON_BSR_PSYCHOLOGY_AND_MOTIVATION_ROUTE,
    FREE_TOOLS_FOR_AUTHORS_ROUTE,
    KDP_TOOLS_ROUTE,
    PUZZLE_GENERATOR_FOR_KDP_ROUTE,
    QR_CODE_GENERATOR_FOR_BOOKS_ROUTE,
    HOW_IT_WORKS_ROUTE,
    ABOUT_ROUTE,
    FAQ_ROUTE,
    BLOG_ROUTE,
    CONTACT_ROUTE,
    AFFILIATE_ROUTE,
    PRIVACY_POLICY_ROUTE,
    TERMS_OF_USE_ROUTE,
    ARC_BOOK_REVIEWS_AMAZON_ROUTE,
    FREE_AMAZON_BOOK_REVIEWS_ROUTE,
    GET_AMAZON_BOOK_REVIEWS_ROUTE,
    KDP_EARNINGS_ROUTE,
    KDP_PROBLEMS_ROUTE,
    KDP_KEYWORD_RESEARCH_ROUTE,
    KDP_NICHE_RESEARCH_ROUTE,
    BOOK_MARKETING_ROUTE,
    AMAZON_ADS_FOR_BOOKS_ROUTE,
    KDP_DISCOVERABILITY_ROUTE,
    AMAZON_BOOK_REVIEW_EXCHANGE_ROUTE,
    AMAZON_REVIEW_EXCHANGE_POLICY_ROUTE,
    AMAZON_REVIEW_RULES_ROUTE,
    HOW_TO_GET_AMAZON_REVIEWS_LEGALLY_ROUTE,
    AMAZON_REVIEW_TIMELINE_ROUTE,
    WHY_AMAZON_REVIEWS_DISAPPEAR_ROUTE,
    BOOK_REVIEW_SITES_FOR_AUTHORS_ROUTE,
    PAID_BOOK_REVIEW_SERVICES_ALTERNATIVES_ROUTE,
    ARE_PAID_AMAZON_REVIEWS_SAFE_ROUTE,
    SAFE_ALTERNATIVE_TO_PAID_BOOK_REVIEWS_ROUTE,
    HOW_MUCH_DO_AUTHORS_MAKE_ON_AMAZON_ROUTE,
    WHY_MY_KDP_BOOK_NOT_SHOWING_ROUTE,
    WHY_MY_BOOK_NOT_SELLING_ROUTE,
    WHY_MY_KDP_BOOK_HAS_NO_SALES_ROUTE,
    HOW_TO_INCREASE_AMAZON_BOOK_SALES_ROUTE,
    KDP_BOOK_NOT_INDEXED_ROUTE,
    HOW_TO_FIX_KDP_INDEXING_ROUTE,
    WHY_MY_BOOK_DISAPPEARED_ROUTE,
    AMAZON_KDP_ACCOUNT_SUSPENDED_ROUTE,
    AMAZON_KDP_ACCOUNT_TERMINATED_ROUTE,
    HOW_TO_RECOVER_KDP_ACCOUNT_ROUTE,
    AMAZON_KDP_POLICY_VIOLATIONS_ROUTE,
    KDP_KEYWORDS_NOT_WORKING_ROUTE,
    KDP_CATEGORY_NOT_SHOWING_ROUTE,
    KDP_BOOK_RANKING_DROPPED_ROUTE,
    WHY_AMAZON_REMOVED_MY_REVIEWS_ROUTE,
    HOW_MUCH_MONEY_CAN_YOU_MAKE_ON_KDP_ROUTE,
    AMAZON_SELF_PUBLISHING_INCOME_ROUTE,
    AMAZON_KDP_ROYALTIES_EXPLAINED_ROUTE,
    AMAZON_KDP_ROYALTY_CALCULATOR_ROUTE,
    HOW_AMAZON_BSR_TRANSLATES_TO_SALES_ROUTE,
    HOW_MUCH_DO_BOOKS_SELL_ON_AMAZON_ROUTE,
    HOW_MANY_BOOKS_DO_YOU_NEED_TO_SELL_TO_MAKE_MONEY_ROUTE,
    CAN_YOU_MAKE_A_LIVING_WITH_KDP_ROUTE,
    KDP_INCOME_CALCULATOR_ROUTE,
    SELF_PUBLISHING_ROI_CALCULATOR_ROUTE,
    AVERAGE_KDP_INCOME_ROUTE,
    KDP_INCOME_EXAMPLES_ROUTE,
    KDP_ROYALTY_RATES_ROUTE,
    KDP_KEYWORD_CLEANER_ROUTE,
    HOW_TO_FIND_KDP_KEYWORDS_ROUTE,
    KDP_KEYWORD_RESEARCH_WITHOUT_TOOLS_ROUTE,
    AMAZON_KDP_KEYWORD_RULES_ROUTE,
    KDP_KEYWORD_MISTAKES_ROUTE,
    HOW_MANY_KEYWORDS_KDP_ROUTE,
    KDP_KEYWORDS_FOR_PUZZLE_BOOKS_ROUTE,
    KDP_KEYWORDS_FOR_SELF_HELP_BOOKS_ROUTE,
    KDP_KEYWORDS_FOR_ROMANCE_BOOKS_ROUTE,
    KDP_KEYWORDS_FOR_COOKBOOKS_ROUTE,
    KDP_KEYWORD_EXAMPLES_ROUTE,
    BEST_KDP_NICHES_FOR_BEGINNERS_ROUTE,
    LOW_COMPETITION_KDP_NICHES_ROUTE,
    PROFITABLE_KDP_NICHES_ROUTE,
    HOW_TO_FIND_KDP_NICHES_ROUTE,
    KDP_NICHE_RESEARCH_WITH_BSR_ROUTE,
    AMAZON_BOOK_NICHE_RESEARCH_ROUTE,
    LOW_CONTENT_BOOK_NICHES_ROUTE,
    NOTEBOOK_NICHES_ROUTE,
    JOURNAL_NICHES_ROUTE,
    PLANNER_NICHES_ROUTE,
    MEDIUM_CONTENT_BOOK_NICHES_ROUTE,
    PUZZLE_BOOKS_KDP_ROUTE,
    SUDOKU_BOOKS_KDP_ROUTE,
    EASY_SUDOKU_BOOKS_KDP_ROUTE,
    HARD_SUDOKU_BOOKS_KDP_ROUTE,
    LARGE_PRINT_SUDOKU_BOOKS_KDP_ROUTE,
    KIDS_SUDOKU_BOOKS_KDP_ROUTE,
    HOW_TO_MARKET_A_BOOK_ROUTE,
    HOW_TO_PROMOTE_A_BOOK_ON_AMAZON_ROUTE,
    BOOK_LAUNCH_STRATEGY_AMAZON_ROUTE,
    BOOK_LAUNCH_CHECKLIST_ROUTE,
    HOW_TO_GET_FIRST_BOOK_SALES_ROUTE,
    FREE_BOOK_MARKETING_STRATEGIES_ROUTE,
    FREE_BOOK_PROMOTION_SITES_ROUTE,
    BOOK_PROMOTION_EMAIL_LISTS_ROUTE,
    BEST_BOOK_PROMOTION_SITES_ROUTE,
    KINDLE_BOOK_PROMOTION_SITES_ROUTE,
    ARC_READERS_FOR_BOOKS_ROUTE,
    HOW_TO_BUILD_ARC_TEAM_ROUTE,
    HOW_TO_GET_BOOK_REVIEWS_BEFORE_LAUNCH_ROUTE,
    HOW_TO_BUILD_AUTHOR_PLATFORM_ROUTE,
    EMAIL_LIST_FOR_AUTHORS_ROUTE,
    HOW_TO_PROMOTE_BOOK_ON_SOCIAL_MEDIA_ROUTE,
    HOW_TO_PROMOTE_BOOK_ON_FACEBOOK_ROUTE,
    HOW_TO_PROMOTE_BOOK_ON_TIKTOK_ROUTE,
    BOOK_MARKETING_CHECKLIST_ROUTE,
    BOOK_MARKETING_STRATEGY_FOR_SELF_PUBLISHED_AUTHORS_ROUTE,
    HOW_AMAZON_ADS_FOR_BOOKS_WORK_ROUTE,
    AMAZON_ADS_FOR_KDP_BEGINNERS_ROUTE,
    AMAZON_ADS_TYPES_EXPLAINED_ROUTE,
    AMAZON_ADS_LAUNCH_STRATEGY_ROUTE,
    AMAZON_ADS_KEYWORD_STRATEGY_ROUTE,
    AMAZON_ADS_FOR_BOOK_LAUNCH_ROUTE,
    AMAZON_ADS_OPTIMIZATION_STRATEGY_ROUTE,
    HOW_TO_LOWER_ACOS_AMAZON_ADS_ROUTE,
    HOW_TO_IMPROVE_AMAZON_ADS_CONVERSION_ROUTE,
    HOW_TO_SCALE_AMAZON_ADS_FOR_BOOKS_ROUTE,
    AMAZON_ADS_BUDGET_STRATEGY_ROUTE,
    AMAZON_ADS_BIDDING_STRATEGY_ROUTE,
    AMAZON_ADS_ACOS_EXPLAINED_ROUTE,
    AMAZON_ADS_CTR_EXPLAINED_ROUTE,
    AMAZON_ADS_ROAS_EXPLAINED_ROUTE,
    WHY_AMAZON_ADS_NOT_WORKING_ROUTE,
    AMAZON_ADS_NO_IMPRESSIONS_ROUTE,
    AMAZON_ADS_NO_CLICKS_ROUTE,
    AMAZON_ADS_HIGH_ACOS_PROBLEM_ROUTE,
    HOW_AMAZON_BOOK_RANKING_WORKS_ROUTE,
    HOW_TO_RANK_BOOKS_ON_AMAZON_ROUTE,
    HOW_TO_GET_BOOK_DISCOVERED_ROUTE,
    HOW_AMAZON_KDP_ALGORITHM_WORKS_ROUTE,
    AMAZON_BOOK_RANKING_FACTORS_ROUTE,
    AMAZON_BSR_VS_DISCOVERABILITY_ROUTE,
    HOW_AMAZON_KEYWORDS_RANKING_WORKS_ROUTE,
    HOW_TO_RANK_FOR_AMAZON_KEYWORDS_ROUTE,
    AMAZON_KDP_KEYWORD_STRATEGY_ROUTE,
    HOW_AMAZON_BOOK_CATEGORIES_WORK_ROUTE,
    HOW_TO_RANK_IN_AMAZON_CATEGORIES_ROUTE,
    KDP_CATEGORY_STRATEGY_ROUTE,
    HOW_REVIEWS_AFFECT_RANKING_ROUTE,
    HOW_CLICKS_AFFECT_AMAZON_RANKING_ROUTE,
    HOW_SALES_AFFECT_AMAZON_RANKING_ROUTE,
    KDP_RISKS_AND_BANS_ROUTE,
    BAN_FOR_COPYRIGHT_VIOLATION_ROUTE,
    BAN_FOR_FAKE_REVIEWS_ROUTE,
    HOW_TO_GET_AMAZON_REVIEWS_SAFELY_ROUTE,
    PRICING_ROUTE,
    VERIFIED_PURCHASE_AMAZON_BOOK_REVIEWS_ROUTE, ARE_AMAZON_BOOK_REVIEWS_HARD_TO_GET_ROUTE,
} from "../../../utils/consts";


















export const PAGE_REGISTRY = {
    main: {
        route: "/",
        labels: {
            top: "",
            bottom: "",
            anchor: "Virtalibry",
        },
        outbound: {
            top: [],
            bottom: [],
        },
    },
    howItWorks: {
        route: HOW_IT_WORKS_ROUTE,
        labels: {
            top: "Understand the Virtalibry workflow and explore the core publishing tools:",
            bottom: "Continue exploring deeper KDP research and publishing strategy tools:",
            anchor: "Learn how Virtalibry works",
        },

        outbound: {

            top: [
                "kdpToolsHub",
                "amazonBsrCalc",
                "aiToolsForKdp",
                "freeToolsForAuthors",
                "selfPublishingRoiCalc",
            ],

            bottom: [
                "amazonBsrCalc",
                "amazonBsrHowTo",
                "amazonBsrPsychology",
                "averageKdpIncome",
                "kdpIncomeExamples",
                "selfPublishingRoiCalc",
                "aiToolsForKdp",
                "freeToolsForAuthors"
            ],

        },

    },
    aboutVirtalibry: {
        route: ABOUT_ROUTE,
        labels: {
            top: "Explore the main Virtalibry platform and tool pages:",
            bottom: "Continue with the main KDP growth and publishing tools:",
            anchor: "About Virtalibry",
        },
        outbound: {
            top: ["howItWorks", "kdpToolsHub", "freeToolsForAuthors"],
            bottom: ["kdpToolsHub", "amazonBsrCalc", "aiToolsForKdp", "kdpKeywordResearch", "kdpNicheResearch", "bookMarketing"],
        },
    },
    faqPublic: {
        route: FAQ_ROUTE,
        pageKey: "faqPublic",
        textMode: "faqPublic",
        labels: {
            top: "Explore the main Virtalibry platform pages:",
            bottom: "Continue with the core KDP growth and tools pages:",
            anchor: "Virtalibry FAQ",
        },
        outbound: {
            top: ["aboutVirtalibry", "howItWorks", "kdpToolsHub"],
            bottom: ["aboutVirtalibry", "howItWorks", "kdpToolsHub", "aiToolsForKdp", "freeToolsForAuthors"],
        },
    },
    pricingPublic: {
        route: PRICING_ROUTE,
        labels: {
            top: "Explore more Virtalibry pages:",
            bottom: "More pages about Virtalibry tools, workflows, and support:",
            anchor: "Pricing"
        },
        outbound: {
            top: ["howItWorks", "faqPublic", "contactPublic"],
            bottom: ["getAmazonBookReviews", "kdpTools", "affiliateProgram"]
        },
    },
    blog: {
        route: BLOG_ROUTE,
        pageKey: "blog",
        textMode: "blog",
        labels: {
            top: "Explore the main Virtalibry platform and tools pages:",
            bottom: "Continue with the core KDP growth and tools hubs:",
            anchor: "Virtalibry Blog",
        },
        outbound: {
            top: ["aboutVirtalibry", "howItWorks", "kdpToolsHub"],
            bottom: ["aboutVirtalibry", "faqPublic", "kdpToolsHub", "aiToolsForKdp", "freeToolsForAuthors"],
        },
    },
    contact: {
        route: CONTACT_ROUTE,
        pageKey: "contact",
        textMode: "contact",
        labels: {
            top: "Explore the main Virtalibry information pages:",
            bottom: "Continue with the core tools and support pages:",
            anchor: "Contact Virtalibry",
        },
        outbound: {
            top: ["aboutVirtalibry", "faqPublic", "howItWorks"],
            bottom: ["aboutVirtalibry", "faqPublic", "kdpToolsHub", "aiToolsForKdp", "freeToolsForAuthors"],
        },
    },
    affiliate: {
        route: AFFILIATE_ROUTE,
        labels: {
            top: "Explore the main Virtalibry platform and tools pages:",
            bottom: "Continue with the core KDP growth and tools hubs:",
            anchor: "Virtalibry Affiliate Program",
        },
        outbound: {
            top: [
                "aboutVirtalibry",
                "howItWorks",
                "kdpToolsHub",
                "kdpDiscoverability",
                "aiToolsForKdp"
            ],
            bottom: [
                "aboutVirtalibry",
                "howItWorks",
                "faqPublic",
                "kdpToolsHub",
                "kdpDiscoverability",
                "aiToolsForKdp",
                "freeToolsForAuthors",
                "getAmazonBookReviews",
                "freeAmazonBookReviews"
            ],
        },
    },
    privacyPolicy: {
        route: PRIVACY_POLICY_ROUTE,
        pageKey: "privacyPolicy",
        textMode: "privacyPolicy",
        labels: {
            top: "Explore the main Virtalibry information pages:",
            bottom: "Continue with related public platform pages:",
            anchor: "Privacy Policy",
        },
        outbound: {
            top: ["aboutVirtalibry", "howItWorks", "kdpToolsHub"],
            bottom: ["aboutVirtalibry", "faqPublic", "kdpToolsHub", "aiToolsForKdp", "freeToolsForAuthors"],
        },
    },
    termsOfUse: {
        route: TERMS_OF_USE_ROUTE,
        pageKey: "termsOfUse",
        textMode: "termsOfUse",
        labels: {
            top: "Explore the main Virtalibry public information pages:",
            bottom: "Continue with related legal and support pages:",
            anchor: "Terms of Use",
        },
        outbound: {
            top: ["aboutVirtalibry", "howItWorks", "kdpToolsHub"],
            bottom: ["aboutVirtalibry", "faqPublic", "kdpToolsHub", "aiToolsForKdp", "freeToolsForAuthors"],
        },
    },

    getAmazonBookReviews: {
        route: GET_AMAZON_BOOK_REVIEWS_ROUTE,
        labels: {
            top: "Start with the main review paths authors use to build Amazon book reviews:",
            bottom: "Explore the full Amazon review ecosystem for authors, including policy, timing, platforms, and safer alternatives:",
            anchor: "Get Amazon Book Reviews",
        },
        outbound: {
            top: ["arcBookReviews", "freeAmazonBookReviews", "bookReviewSitesForAuthors", "amazonReviewRules"],
            bottom: ["arcBookReviews", "freeAmazonBookReviews", "bookReviewSitesForAuthors",
                "amazonBookReviewExchange", "amazonReviewRules", "arePaidAmazonReviewsSafe", "safeAlternativeToPaidBookReviews"],
        },
    },
    arcBookReviews: {
        route: ARC_BOOK_REVIEWS_AMAZON_ROUTE,
        labels: {
            top: "Start with the main page and related review paths for launch-focused authors:",
            bottom: "Continue with legal review strategy, review timing, and the broader Amazon reviews hub:",
            anchor: "ARC Book Reviews for Amazon",
        },
        outbound: {
            top: ["getAmazonBookReviews", "freeAmazonBookReviews", "howToGetAmazonReviewsLegally", "bookReviewSitesForAuthors"],
            bottom: ["getAmazonBookReviews", "freeAmazonBookReviews", "howToGetAmazonReviewsLegally", "amazonReviewTimeline", "bookReviewSitesForAuthors", "amazonReviewRules", "kdpDiscoverability"],
        },
    },
    freeAmazonBookReviews: {
        route: FREE_AMAZON_BOOK_REVIEWS_ROUTE,
        pageKey: "freeAmazonBookReviews",
        textMode: "freeAmazonBookReviews",
        labels: {
            top: "Explore the main page and the most relevant review paths for free and ethical review growth:",
            bottom: "Continue with ARC workflows, review exchange explanations, and safer long-term review strategies:",
            anchor: "Free Amazon Book Reviews",
        },
        outbound: {
            top: ["getAmazonBookReviews", "arcBookReviews", "bookReviewSitesForAuthors", "howToGetAmazonReviewsLegally"],
            bottom: ["getAmazonBookReviews", "arcBookReviews", "bookReviewSitesForAuthors", "howToGetAmazonReviewsLegally", "amazonReviewRules", "safeAlternativeToPaidBookReviews", "kdpDiscoverability"],
        },
    },
    verifiedPurchaseAmazonBookReviews: {
        route: VERIFIED_PURCHASE_AMAZON_BOOK_REVIEWS_ROUTE,
        pageKey: "verifiedPurchaseAmazonBookReviews",
        textMode: "verifiedPurchaseAmazonBookReviews",
        labels: {
            top: "Start with the main reviews page and the key pages about Verified Purchase, legal review strategy, and review rules:",
            bottom: "Explore more pages about Verified Purchase reviews, legal review workflows, timelines, disappearing reviews, and review rules:",
            anchor: "Verified Purchase Amazon Book Reviews",
        },
        outbound: {
            top: ["getAmazonBookReviews", "howToGetAmazonReviewsLegally", "amazonReviewRules"],
            bottom: [
                "amazonReviewRules",
                "howToGetAmazonReviewsLegally",
                "amazonReviewTimeline",
                "whyAmazonReviewsDisappear",
                "getAmazonBookReviews",
            ],
        },
    },
    areAmazonBookReviewsHardToGet: {
        route: ARE_AMAZON_BOOK_REVIEWS_HARD_TO_GET_ROUTE,
        pageKey: "areAmazonBookReviewsHardToGet",
        textMode: "areAmazonBookReviewsHardToGet",
        labels: {
            top: "Start with the main reviews page and the key pages about review difficulty, legal strategy, and review rules:",
            bottom: "Explore more pages about why reviews can be hard to get, legal review workflows, timelines, disappearing reviews, and review rules:",
            anchor: "Are Amazon Book Reviews Hard to Get",
        },
        outbound: {
            top: ["getAmazonBookReviews", "amazonReviewRules", "howToGetAmazonReviewsLegally"],
            bottom: [
                "verifiedPurchaseAmazonBookReviews",
                "amazonReviewTimeline",
                "whyAmazonReviewsDisappear",
                "amazonReviewRules",
                "getAmazonBookReviews",
            ],
        },
    },
    // amazonBookReviewExchange: {
    //     route: AMAZON_BOOK_REVIEW_EXCHANGE_ROUTE,
    //     pageKey: "amazonBookReviewExchange",
    //     textMode: "amazonBookReviewExchange",
    //     labels: {
    //         top: "Explore the main review page and the key policy page connected to review exchange:",
    //         bottom: "Continue with exchange policy, review rules, and safer alternatives to exchange-style review growth:",
    //         anchor: "Amazon Book Review Exchange",
    //     },
    //     outbound: {
    //         top: ["getAmazonBookReviews", "freeAmazonBookReviews", "amazonReviewExchangePolicy"],
    //         bottom: ["amazonReviewExchangePolicy", "amazonReviewRules", "howToGetAmazonReviewsLegally", "safeAlternativeToPaidBookReviews", "getAmazonBookReviews"],
    //     },
    // },
    // amazonReviewExchangePolicy: {
    //     route: AMAZON_REVIEW_EXCHANGE_POLICY_ROUTE,
    //     pageKey: "amazonReviewExchangePolicy",
    //     textMode: "amazonReviewExchangePolicy",
    //     labels: {
    //         top: "Start with the exchange explanation page and the broader Amazon review rules hub:",
    //         bottom: "Continue with legal review strategy, review rules, and the main Amazon reviews hub:",
    //         anchor: "Amazon Review Exchange Policy",
    //     },
    //     outbound: {
    //         top: ["amazonBookReviewExchange", "amazonReviewRules", "getAmazonBookReviews"],
    //         bottom: ["amazonBookReviewExchange", "amazonReviewRules", "howToGetAmazonReviewsLegally", "whyAmazonReviewsDisappear", "getAmazonBookReviews"],
    //     },
    // },
    amazonReviewRules: {
        route: AMAZON_REVIEW_RULES_ROUTE,
        pageKey: "amazonReviewRules",
        textMode: "amazonReviewRules",
        labels: {
            top: "Start with the Amazon reviews page and the key pages about legal review strategy and policy:",
            bottom: "Explore the full review policy, including legal reviews, timeline, disappearing reviews, and exchange policy:",
            anchor: "Amazon Review Rules",
        },
        outbound: {
            top: ["getAmazonBookReviews", "howToGetAmazonReviewsLegally", "amazonReviewExchangePolicy"],
            bottom: ["howToGetAmazonReviewsLegally", "amazonReviewTimeline", "whyAmazonReviewsDisappear", "amazonReviewExchangePolicy", "getAmazonBookReviews"],
        },
    },
    // howToGetAmazonReviewsLegally: {
    //     route: HOW_TO_GET_AMAZON_REVIEWS_LEGALLY_ROUTE,
    //     pageKey: "howToGetAmazonReviewsLegally",
    //     textMode: "howToGetAmazonReviewsLegally",
    //     labels: {
    //         top: "Start with the review rules page and the main Amazon reviews hub:",
    //         bottom: "Continue with review timing, disappearing reviews, and safer alternatives to risky review tactics:",
    //         anchor: "How to Get Amazon Reviews Legally",
    //     },
    //     outbound: {
    //         top: ["amazonReviewRules", "getAmazonBookReviews", "freeAmazonBookReviews"],
    //         bottom: ["amazonReviewTimeline", "whyAmazonReviewsDisappear", "safeAlternativeToPaidBookReviews", "freeAmazonBookReviews", "getAmazonBookReviews"],
    //     },
    // },
    // amazonReviewTimeline: {
    //     route: AMAZON_REVIEW_TIMELINE_ROUTE,
    //     pageKey: "amazonReviewTimeline",
    //     textMode: "amazonReviewTimeline",
    //     labels: {
    //         top: "Start with the review rules page and the legal review strategy page:",
    //         bottom: "Continue with ARC workflows, disappearing reviews, and the main Amazon reviews hub:",
    //         anchor: "Amazon Review Timeline",
    //     },
    //     outbound: {
    //         top: ["amazonReviewRules", "howToGetAmazonReviewsLegally", "arcBookReviews"],
    //         bottom: ["whyAmazonReviewsDisappear", "arcBookReviews", "getAmazonBookReviews", "freeAmazonBookReviews", "amazonReviewRules"],
    //     },
    // },
    // whyAmazonReviewsDisappear: {
    //     route: WHY_AMAZON_REVIEWS_DISAPPEAR_ROUTE,
    //     pageKey: "whyAmazonReviewsDisappear",
    //     textMode: "whyAmazonReviewsDisappear",
    //     labels: {
    //         top: "Start with the review rules page and the pages that explain policy and timing:",
    //         bottom: "Continue with review policy, legal review strategy, and the main Amazon reviews hub:",
    //         anchor: "Why Amazon Reviews Disappear",
    //     },
    //     outbound: {
    //         top: ["amazonReviewRules", "amazonReviewTimeline", "amazonReviewExchangePolicy"],
    //         bottom: ["howToGetAmazonReviewsLegally", "amazonReviewExchangePolicy", "getAmazonBookReviews", "safeAlternativeToPaidBookReviews", "amazonReviewRules"],
    //     },
    // },
     bookReviewSitesForAuthors: {
         route: BOOK_REVIEW_SITES_FOR_AUTHORS_ROUTE,
         pageKey: "bookReviewSitesForAuthors",
         textMode: "bookReviewSitesForAuthors",
         labels: {
             top: "Start with the main Amazon reviews page and the pages about free reviews and alternatives:",
            bottom: "Continue with paid-review alternatives, safer review strategy, and ARC-focused workflows:",
            anchor: "Book Review Sites for Authors",
        },
        outbound: {
            top: ["getAmazonBookReviews", "freeAmazonBookReviews", "paidBookReviewServicesAlternatives"],
            bottom: ["paidBookReviewServicesAlternatives", "safeAlternativeToPaidBookReviews", "arcBookReviews", "howToGetAmazonReviewsLegally", "getAmazonBookReviews"],
        },
    },
    // paidBookReviewServicesAlternatives: {
    //     route: PAID_BOOK_REVIEW_SERVICES_ALTERNATIVES_ROUTE,
    //     pageKey: "paidBookReviewServicesAlternatives",
    //     textMode: "paidBookReviewServicesAlternatives",
    //     labels: {
    //         top: "Start with the comparison page and the safety-focused pages around paid reviews:",
    //         bottom: "Continue with safer alternatives, legal review strategy, and the main Amazon reviews hub:",
    //         anchor: "Paid Book Review Services Alternatives",
    //     },
    //     outbound: {
    //         top: ["bookReviewSitesForAuthors", "arePaidAmazonReviewsSafe", "safeAlternativeToPaidBookReviews"],
    //         bottom: ["safeAlternativeToPaidBookReviews", "howToGetAmazonReviewsLegally", "freeAmazonBookReviews", "getAmazonBookReviews", "bookReviewSitesForAuthors"],
    //     },
    // },
    // arePaidAmazonReviewsSafe: {
    //     route: ARE_PAID_AMAZON_REVIEWS_SAFE_ROUTE,
    //     pageKey: "arePaidAmazonReviewsSafe",
    //     textMode: "arePaidAmazonReviewsSafe",
    //     labels: {
    //         top: "Start with the alternatives pages and the review rules hub:",
    //         bottom: "Continue with safer alternatives, legal review strategy, and the main Amazon reviews hub:",
    //         anchor: "Are Paid Amazon Reviews Safe",
    //     },
    //     outbound: {
    //         top: ["paidBookReviewServicesAlternatives", "safeAlternativeToPaidBookReviews", "amazonReviewRules"],
    //         bottom: ["safeAlternativeToPaidBookReviews", "howToGetAmazonReviewsLegally", "amazonReviewRules", "getAmazonBookReviews", "freeAmazonBookReviews"],
    //     },
    // },
    // safeAlternativeToPaidBookReviews: {
    //     route: SAFE_ALTERNATIVE_TO_PAID_BOOK_REVIEWS_ROUTE,
    //     pageKey: "safeAlternativeToPaidBookReviews",
    //     textMode: "safeAlternativeToPaidBookReviews",
    //     labels: {
    //         top: "Start with the paid-review fear and alternatives pages:",
    //         bottom: "Continue with free reviews, legal review strategy, and the main Amazon reviews hub:",
    //         anchor: "Safe Alternative to Paid Book Reviews",
    //     },
    //     outbound: {
    //         top: ["arePaidAmazonReviewsSafe", "paidBookReviewServicesAlternatives", "freeAmazonBookReviews"],
    //         bottom: ["howToGetAmazonReviewsLegally", "freeAmazonBookReviews", "arcBookReviews", "getAmazonBookReviews", "bookReviewSitesForAuthors"],
    //     },
    // },

    kdpToolsHub: {
        route: KDP_TOOLS_ROUTE,
        labels: {
            top: "Start with the tool that matches your current publishing task:",
            bottom: "Explore the KDP tools and supporting pages in this publishing tools hub:",
            anchor: "Open KDP Tools Page",
        },
        outbound: {
            top: ["amazonBsrCalc", "aiToolsForKdp", "freeToolsForAuthors", "aiBookCategoryFinder",],
            bottom: [
                "amazonBsrCalc",
                "amazonBsrHowTo",
                "amazonBsrPsychology",
                "aiToolsForKdp",
                "aiBookTitleGenerator",
                "aiBookDescriptionGenerator",
                "aiBookKeyWordGenerator",
                "aiBookCategoryFinder",
                "freeToolsForAuthors",
                "qrCodeGenForBooks",
                "puzzleGenForKdp",
            ],
        },
    },
    amazonBsrCalc: {
        route: AMAZON_BSR_CALCULATOR_ROUTE,
        labels: {
            top: "New to BSR or want to read results correctly?",
            bottom: "Want to go deeper and avoid common BSR mistakes?",
            anchor: "Open the Amazon BSR Calculator",
        },
        outbound: {
            top: ["kdpToolsHub", "amazonBsrHowTo", "amazonBsrPsychology"],
            bottom: ["amazonBsrHowTo", "amazonBsrPsychology", "aiToolsForKdp", "freeToolsForAuthors"],
        },
    },
    amazonBsrHowTo: {
        route: AMAZON_BSR_CALCULATOR_HOW_TO_USE_ROUTE,
        labels: {
            top: "Want to try the calculator while reading the guide?",
            bottom: "Continue exploring related BSR pages:",
            anchor: "How to use the BSR Calculator?",
        },
        outbound: {
            top: ["amazonBsrCalc", "amazonBsrPsychology", "kdpToolsHub"],
            bottom: ["amazonBsrCalc", "amazonBsrPsychology", "aiToolsForKdp"],
        },
    },
    amazonBsrPsychology: {
        route: AMAZON_BSR_PSYCHOLOGY_AND_MOTIVATION_ROUTE,
        labels: {
            top: "Feeling distracted by rank swings? Start from the numbers:",
            bottom: "Continue with practical BSR pages:",
            anchor: "Read how to interpret BSR calmly",
        },
        outbound: {
            top: ["amazonBsrCalc", "amazonBsrHowTo", "kdpToolsHub"],
            bottom: ["amazonBsrCalc", "amazonBsrHowTo", "aiToolsForKdp"],
        },
    },

    aiToolsForKdp: {
        route: AI_TOOLS_FOR_KDP_ROUTE,
        labels: {
            top: "Looking for surrounding KDP strategy tools?",
            bottom: "Open one of the AI metadata tools:",
            anchor: "Open AI Tools for KDP",
        },
        outbound: {
            top: ["kdpToolsHub", "amazonBsrCalc", "freeToolsForAuthors"],
            bottom: ["aiBookTitleGenerator", "aiBookDescriptionGenerator", "aiBookKeyWordGenerator", "aiBookCategoryFinder", "amazonBsrCalc", "freeToolsForAuthors"],
        },
    },
    aiBookTitleGenerator: {
        route: AI_BOOK_TITLE_GENERATOR_ROUTE,
        labels: {
            top: "Looking for the broader KDP tools cluster?",
            bottom: "Continue with related AI metadata tools:",
            anchor: "Try the AI Book Title Generator",
        },
        outbound: {
            top: ["aiToolsForKdp", "kdpToolsHub", "amazonBsrCalc"],
            bottom: ["aiBookDescriptionGenerator", "aiBookKeyWordGenerator", "aiBookCategoryFinder", "freeToolsForAuthors"],
        },
    },
    aiBookDescriptionGenerator: {
        route: AI_BOOK_DESCRIPTION_GENERATOR_ROUTE,
        labels: {
            top: "Looking for the broader KDP tools cluster?",
            bottom: "Continue with related AI metadata tools:",
            anchor: "Try the AI Book Description Generator",
        },
        outbound: {
            top: ["aiToolsForKdp", "kdpToolsHub", "amazonBsrCalc"],
            bottom: ["aiBookTitleGenerator", "aiBookKeyWordGenerator", "aiBookCategoryFinder", "freeToolsForAuthors"],
        },
    },
    aiBookCategoryFinder: {
        route: AI_BOOK_CATEGORY_FINDER_ROUTE,
        labels: {
            top: "Looking for the broader KDP tools cluster?",
            bottom: "Continue with related AI metadata tools:",
            anchor: "Try the AI Book Category Finder",
        },
        outbound: {
            top: ["aiToolsForKdp", "kdpToolsHub", "amazonBsrCalc"],
            bottom: ["aiBookTitleGenerator", "aiBookDescriptionGenerator", "aiBookKeyWordGenerator", "freeToolsForAuthors"],
        },
    },

    freeToolsForAuthors: {
        route: FREE_TOOLS_FOR_AUTHORS_ROUTE,
        labels: {
            top: "Looking for other KDP utilities?",
            bottom: "Pick a free tool:",
            anchor: "Open Free Tools for Authors",
        },
        outbound: {
            top: ["kdpToolsHub", "qrCodeGenForBooks", "puzzleGenForKdp"],
            bottom: ["qrCodeGenForBooks", "puzzleGenForKdp", "aiToolsForKdp", "amazonBsrCalc"],
        },
    },
    qrCodeGenForBooks: {
        route: QR_CODE_GENERATOR_FOR_BOOKS_ROUTE,
        labels: {
            top: "Looking for the broader tools cluster?",
            bottom: "Continue with related author tools:",
            anchor: "Open the QR Code Generator for Books",
        },
        outbound: {
            top: ["freeToolsForAuthors", "puzzleGenForKdp", "kdpToolsHub"],
            bottom: ["puzzleGenForKdp", "aiToolsForKdp", "amazonBsrCalc"],
        },
    },
    puzzleGenForKdp: {
        route: PUZZLE_GENERATOR_FOR_KDP_ROUTE,
        labels: {
            top: "Explore the surrounding author tools cluster:",
            bottom: "Continue with related publishing tools:",
            anchor: "Open the Puzzle Generator for KDP",
        },
        outbound: {
            top: ["freeToolsForAuthors", "qrCodeGenForBooks", "kdpToolsHub"],
            bottom: ["qrCodeGenForBooks", "aiToolsForKdp", "amazonBsrCalc"],
        },
    },

    kdpKeywordResearch: {
        route: KDP_KEYWORD_RESEARCH_ROUTE,
        pageKey: "kdpKeywordResearch",
        textMode: "kdpKeywordResearch",
        labels: {
            top: "Start with the most relevant KDP keyword research and Amazon search strategy pages:",
            bottom: "Continue exploring keyword tools, rules, examples, and niche-specific keyword guides:",
            anchor: "KDP Keyword Research",
        },
        outbound: {
            top: ["aiBookKeyWordGenerator", "aiToolsForKdp",
                "howToFindKdpKeywords",
                "amazonKdpKeywordRules",
                "kdpKeywordExamples",
                "kdpKeywordMistakes"
            ],
            bottom: ["getAmazonBookReviews",
                "howToFindKdpKeywords",
                "kdpKeywordResearchWithoutTools",
                "amazonKdpKeywordRules",
                "kdpKeywordMistakes",
                "howManyKeywordsKdp",
                "kdpKeywordExamples",
                "aiBookKeywordGenerator",
                "kdpKeywordCleaner",
                "kdpKeywordsForPuzzleBooks",
                "kdpKeywordsForSelfHelpBooks",
                "kdpKeywordsForRomanceBooks",
                "kdpKeywordsForCookbooks"
            ]
        },
    },
    aiBookKeyWordGenerator: {
        route: AI_BOOK_KEYWORD_GENERATOR_ROUTE,
        pageKey: "aiBookKeyWordGenerator",
        textMode: "aiKeyWordAssist",
        labels: {
            top: "Looking for the broader KDP tools cluster?",
            bottom: "Continue with related AI metadata tools:",
            anchor: "Try the AI Book Keyword Generator",
        },
        outbound: {
            top: ["aiToolsForKdp", "kdpToolsHub", "amazonBsrCalc"],
            bottom: ["aiBookTitleGenerator", "aiBookDescriptionGenerator", "aiBookCategoryFinder", "freeToolsForAuthors"],
        },
    },
    // kdpKeywordCleaner: {
    //     route: KDP_KEYWORD_CLEANER_ROUTE,
    //     pageKey: "kdpKeywordCleaner",
    //     textMode: "kdpKeywordCleaner",
    //     labels: {
    //         top: "Start with the most relevant keyword cleanup and research pages:",
    //         bottom: "Continue with related Amazon keyword guides and metadata tools:",
    //         anchor: "KDP Keyword Cleaner",
    //     },
    //     outbound: {
    //         top: ["kdpKeywordResearch", "aiBookKeywordGenerator", "aiToolsForKdp"],
    //         bottom: ["howToFindKdpKeywords", "amazonKdpKeywordRules", "kdpKeywordMistakes", "kdpKeywordExamples", "freeToolsForAuthors"],
    //     },
    // },
    // howToFindKdpKeywords: {
    //     route: HOW_TO_FIND_KDP_KEYWORDS_ROUTE,
    //     pageKey: "howToFindKdpKeywords",
    //     textMode: "howToFindKdpKeywords",
    //     labels: {
    //         top: "Start with the most relevant Amazon keyword research and discovery pages:",
    //         bottom: "Continue with related KDP keyword guides, tools, and optimization pages:",
    //         anchor: "How to Find KDP Keywords",
    //     },
    //     outbound: {
    //         top: ["kdpKeywordResearch", "aiBookKeywordGenerator", "kdpKeywordCleaner"],
    //         bottom: ["kdpKeywordResearchWithoutTools", "amazonKdpKeywordRules", "kdpKeywordMistakes", "kdpKeywordExamples", "freeToolsForAuthors"],
    //     },
    // },
    // kdpKeywordResearchWithoutTools: {
    //     route: KDP_KEYWORD_RESEARCH_WITHOUT_TOOLS_ROUTE,
    //     pageKey: "kdpKeywordResearchWithoutTools",
    //     textMode: "kdpKeywordResearchWithoutTools",
    //     labels: {
    //         top: "Start with the most relevant manual keyword research and discovery pages:",
    //         bottom: "Continue with related Amazon keyword guides, cleanup tools, and examples:",
    //         anchor: "KDP Keyword Research Without Tools",
    //     },
    //     outbound: {
    //         top: ["kdpKeywordResearch", "howToFindKdpKeywords", "kdpKeywordCleaner"],
    //         bottom: ["amazonKdpKeywordRules", "kdpKeywordMistakes", "kdpKeywordExamples", "aiBookKeywordGenerator", "freeToolsForAuthors"],
    //     },
    // },
    // amazonKdpKeywordRules: {
    //     route: AMAZON_KDP_KEYWORD_RULES_ROUTE,
    //     pageKey: "amazonKdpKeywordRules",
    //     textMode: "amazonKdpKeywordRules",
    //     labels: {
    //         top: "Start with the most relevant Amazon keyword policy and research pages:",
    //         bottom: "Continue with related KDP keyword guides, cleanup tools, and examples:",
    //         anchor: "Amazon KDP Keyword Rules",
    //     },
    //     outbound: {
    //         top: ["kdpKeywordResearch", "howToFindKdpKeywords", "kdpKeywordResearchWithoutTools"],
    //         bottom: ["kdpKeywordMistakes", "howManyKeywordsKdp", "kdpKeywordExamples", "kdpKeywordCleaner", "freeToolsForAuthors"],
    //     },
    // },
    // kdpKeywordMistakes: {
    //     route: KDP_KEYWORD_MISTAKES_ROUTE,
    //     pageKey: "kdpKeywordMistakes",
    //     textMode: "kdpKeywordMistakes",
    //     labels: {
    //         top: "Start with the most relevant Amazon keyword research and optimization pages:",
    //         bottom: "Continue with related KDP keyword guides and tools:",
    //         anchor: "KDP Keyword Mistakes",
    //     },
    //     outbound: {
    //         top: ["kdpKeywordResearch", "howToFindKdpKeywords", "amazonKdpKeywordRules"],
    //         bottom: ["howManyKeywordsKdp", "kdpKeywordExamples", "kdpKeywordCleaner", "aiBookKeywordGenerator", "freeToolsForAuthors"],
    //     },
    // },
    // howManyKeywordsKdp: {
    //     route: HOW_MANY_KEYWORDS_KDP_ROUTE,
    //     pageKey: "howManyKeywordsKdp",
    //     textMode: "howManyKeywordsKdp",
    //     labels: {
    //         top: "Start with the most relevant KDP keyword limit and metadata pages:",
    //         bottom: "Continue with related Amazon keyword guides, rules, and examples:",
    //         anchor: "How Many Keywords Does KDP Allow?",
    //     },
    //     outbound: {
    //         top: ["kdpKeywordResearch", "amazonKdpKeywordRules", "howToFindKdpKeywords"],
    //         bottom: ["kdpKeywordExamples", "kdpKeywordMistakes", "kdpKeywordCleaner", "kdpKeywordResearchWithoutTools", "freeToolsForAuthors"],
    //     },
    // },
    // kdpKeywordsForPuzzleBooks: {
    //     route: KDP_KEYWORDS_FOR_PUZZLE_BOOKS_ROUTE,
    //     pageKey: "kdpKeywordsForPuzzleBooks",
    //     textMode: "kdpKeywordsForPuzzleBooks",
    //     labels: {
    //         top: "Start with the most relevant puzzle-book keyword and Amazon discovery pages:",
    //         bottom: "Continue with related KDP keyword guides, tools, and niche examples:",
    //         anchor: "KDP Keywords for Puzzle Books",
    //     },
    //     outbound: {
    //         top: ["kdpKeywordResearch", "howToFindKdpKeywords", "kdpKeywordExamples"],
    //         bottom: ["kdpKeywordCleaner", "kdpKeywordMistakes", "amazonKdpKeywordRules", "aiBookKeywordGenerator", "freeToolsForAuthors"],
    //     },
    // },
    // kdpKeywordsForSelfHelpBooks: {
    //     route: KDP_KEYWORDS_FOR_SELF_HELP_BOOKS_ROUTE,
    //     pageKey: "kdpKeywordsForSelfHelpBooks",
    //     textMode: "kdpKeywordsForSelfHelpBooks",
    //     labels: {
    //         top: "Start with the most relevant self-help keyword and Amazon discovery pages:",
    //         bottom: "Continue with related KDP keyword guides, tools, and niche examples:",
    //         anchor: "KDP Keywords for Self-Help Books",
    //     },
    //     outbound: {
    //         top: ["kdpKeywordResearch", "howToFindKdpKeywords", "kdpKeywordExamples"],
    //         bottom: ["kdpKeywordCleaner", "kdpKeywordMistakes", "amazonKdpKeywordRules", "aiBookKeywordGenerator", "freeToolsForAuthors"],
    //     },
    // },
    // kdpKeywordsForRomanceBooks: {
    //     route: KDP_KEYWORDS_FOR_ROMANCE_BOOKS_ROUTE,
    //     pageKey: "kdpKeywordsForRomanceBooks",
    //     textMode: "kdpKeywordsForRomanceBooks",
    //     labels: {
    //         top: "Start with the most relevant romance keyword and Amazon discovery pages:",
    //         bottom: "Continue with related KDP keyword guides, tools, and niche examples:",
    //         anchor: "KDP Keywords for Romance Books",
    //     },
    //     outbound: {
    //         top: ["kdpKeywordResearch", "howToFindKdpKeywords", "kdpKeywordExamples"],
    //         bottom: ["kdpKeywordCleaner", "kdpKeywordMistakes", "amazonKdpKeywordRules", "aiBookKeywordGenerator", "freeToolsForAuthors"],
    //     },
    // },
    // kdpKeywordsForCookbooks: {
    //     route: KDP_KEYWORDS_FOR_COOKBOOKS_ROUTE,
    //     pageKey: "kdpKeywordsForCookbooks",
    //     textMode: "kdpKeywordsForCookbooks",
    //     labels: {
    //         top: "Start with the most relevant cookbook keyword and Amazon discovery pages:",
    //         bottom: "Continue with related KDP keyword guides, tools, and niche examples:",
    //         anchor: "KDP Keywords for Cookbooks",
    //     },
    //     outbound: {
    //         top: ["kdpKeywordResearch", "howToFindKdpKeywords", "kdpKeywordExamples"],
    //         bottom: ["kdpKeywordCleaner", "kdpKeywordMistakes", "amazonKdpKeywordRules", "aiBookKeywordGenerator", "freeToolsForAuthors"],
    //     },
    // },
    // kdpKeywordExamples: {
    //     route: KDP_KEYWORD_EXAMPLES_ROUTE,
    //     pageKey: "kdpKeywordExamples",
    //     textMode: "kdpKeywordExamples",
    //     labels: {
    //         top: "Start with the most relevant Amazon keyword example and discovery pages:",
    //         bottom: "Continue with related KDP keyword guides, rules, and optimization tools:",
    //         anchor: "KDP Keyword Examples",
    //     },
    //     outbound: {
    //         top: ["kdpKeywordResearch", "howToFindKdpKeywords", "aiBookKeywordGenerator"],
    //         bottom: ["kdpKeywordCleaner", "kdpKeywordMistakes", "amazonKdpKeywordRules", "howManyKeywordsKdp", "freeToolsForAuthors"],
    //     },
    // },

    kdpNicheResearch: {
        route: KDP_NICHE_RESEARCH_ROUTE,
        labels: {
            top: "Explore pages that help evaluate niche opportunities and market demand:",
            bottom: "Continue with related KDP tools and publishing strategy pages:",
            anchor: "KDP Niche Research",
        },
        outbound: {
            top: ["kdpKeywordResearch", "aiBookKeyWordGenerator", "aiToolsForKdp",
                "bestKdpNichesForBeginners",
                "lowCompetitionKdpNiches",
                "profitableKdpNiches",
                "howToFindKdpNiches"
            ],
            bottom: [ "kdpToolsHub", "kdpDiscoverability",
                "bestKdpNichesForBeginners",
                "lowCompetitionKdpNiches",
                "profitableKdpNiches",
                "howToFindKdpNiches",
                "kdpNicheResearchWithBsr",
                "amazonBookNicheResearch",

                "lowContentBookNiches",
                "notebookNiches",
                "journalNiches",
                "plannerNiches",

                "mediumContentBookNiches",
                "puzzleBooksKdp",
                "sudokuBooksKdp",

                "fictionBookNiches",
                "nonfictionBookNiches",
                "selfHelpBookNiches",
                "cookbookNiches",

                "kdpNicheMistakes",
                "howToValidateBookNiche",
                "howToAnalyzeBookCompetition"
            ]
        },
    },
    // bestKdpNichesForBeginners: {
    //     route: BEST_KDP_NICHES_FOR_BEGINNERS_ROUTE,
    //     pageKey: "bestKdpNichesForBeginners",
    //     textMode: "bestKdpNichesForBeginners",
    //     labels: {
    //         top: "Start with the most relevant beginner KDP niche research guides:",
    //         bottom: "Continue exploring niche research tools and niche discovery strategies:",
    //         anchor: "Best KDP Niches for Beginners",
    //     },
    //     outbound: {
    //         top: ["kdpNicheResearch", "howToFindKdpNiches", "lowCompetitionKdpNiches"],
    //         bottom: ["kdpNicheResearchWithBsr", "amazonBookNicheResearch", "lowContentBookNiches", "mediumContentBookNiches", "freeToolsForAuthors"],
    //     },
    // },
    // lowCompetitionKdpNiches: {
    //     route: LOW_COMPETITION_KDP_NICHES_ROUTE,
    //     pageKey: "lowCompetitionKdpNiches",
    //     textMode: "lowCompetitionKdpNiches",
    //     labels: {
    //         top: "Start with the most relevant low-competition and niche validation pages:",
    //         bottom: "Continue exploring KDP niche research tools and category opportunities:",
    //         anchor: "Low Competition KDP Niches",
    //     },
    //     outbound: {
    //         top: ["kdpNicheResearch", "kdpNicheResearchWithBsr", "howToFindKdpNiches"],
    //         bottom: ["profitableKdpNiches", "amazonBookNicheResearch", "lowContentBookNiches", "mediumContentBookNiches", "freeToolsForAuthors"],
    //     },
    // },
    // profitableKdpNiches: {
    //     route: PROFITABLE_KDP_NICHES_ROUTE,
    //     pageKey: "profitableKdpNiches",
    //     textMode: "profitableKdpNiches",
    //     labels: {
    //         top: "Start with the most relevant profitable niche and KDP market research pages:",
    //         bottom: "Continue exploring niche validation tools and category opportunities:",
    //         anchor: "Profitable KDP Niches",
    //     },
    //     outbound: {
    //         top: ["kdpNicheResearch", "kdpNicheResearchWithBsr", "lowCompetitionKdpNiches"],
    //         bottom: ["howToFindKdpNiches", "amazonBookNicheResearch", "mediumContentBookNiches", "puzzleBooksKdp", "freeToolsForAuthors"],
    //     },
    // },
    // howToFindKdpNiches: {
    //     route: HOW_TO_FIND_KDP_NICHES_ROUTE,
    //     pageKey: "howToFindKdpNiches",
    //     textMode: "howToFindKdpNiches",
    //     labels: {
    //         top: "Start with the most relevant KDP niche discovery and validation pages:",
    //         bottom: "Continue exploring niche research tools, competition checks, and category opportunities:",
    //         anchor: "How to Find KDP Niches",
    //     },
    //     outbound: {
    //         top: ["kdpNicheResearch", "kdpNicheResearchWithBsr", "amazonBookNicheResearch"],
    //         bottom: ["lowCompetitionKdpNiches", "profitableKdpNiches", "lowContentBookNiches", "mediumContentBookNiches", "freeToolsForAuthors"],
    //     },
    // },
    // kdpNicheResearchWithBsr: {
    //     route: KDP_NICHE_RESEARCH_WITH_BSR_ROUTE,
    //     pageKey: "kdpNicheResearchWithBsr",
    //     textMode: "kdpNicheResearchWithBsr",
    //     labels: {
    //         top: "Start with the most relevant BSR-based niche validation and KDP research pages:",
    //         bottom: "Continue exploring broader niche discovery, competition, and category opportunities:",
    //         anchor: "KDP Niche Research with BSR",
    //     },
    //     outbound: {
    //         top: ["kdpNicheResearch", "howToFindKdpNiches", "lowCompetitionKdpNiches"],
    //         bottom: ["profitableKdpNiches", "amazonBookNicheResearch", "mediumContentBookNiches", "puzzleBooksKdp", "freeToolsForAuthors"],
    //     },
    // },
    // amazonBookNicheResearch: {
    //     route: AMAZON_BOOK_NICHE_RESEARCH_ROUTE,
    //     pageKey: "amazonBookNicheResearch",
    //     textMode: "amazonBookNicheResearch",
    //     labels: {
    //         top: "Start with the most relevant Amazon book market and niche research pages:",
    //         bottom: "Continue exploring niche discovery methods, validation tools, and category opportunities:",
    //         anchor: "Amazon Book Niche Research",
    //     },
    //     outbound: {
    //         top: ["kdpNicheResearch", "howToFindKdpNiches", "kdpNicheResearchWithBsr"],
    //         bottom: ["lowCompetitionKdpNiches", "profitableKdpNiches", "lowContentBookNiches", "mediumContentBookNiches", "freeToolsForAuthors"],
    //     },
    // },
    // lowContentBookNiches: {
    //     route: LOW_CONTENT_BOOK_NICHES_ROUTE,
    //     pageKey: "lowContentBookNiches",
    //     textMode: "lowContentBookNiches",
    //     labels: {
    //         top: "Start with the most relevant low-content and KDP niche research pages:",
    //         bottom: "Continue exploring specific low-content niche families and related publishing opportunities:",
    //         anchor: "Low Content Book Niches",
    //     },
    //     outbound: {
    //         top: ["kdpNicheResearch", "bestKdpNichesForBeginners", "lowCompetitionKdpNiches"],
    //         bottom: ["notebookNiches", "journalNiches", "plannerNiches", "mediumContentBookNiches", "freeToolsForAuthors"],
    //     },
    // },
    // notebookNiches: {
    //     route: NOTEBOOK_NICHES_ROUTE,
    //     pageKey: "notebookNiches",
    //     textMode: "notebookNiches",
    //     labels: {
    //         top: "Start with the most relevant low-content and notebook niche research pages:",
    //         bottom: "Continue exploring related low-content niche families:",
    //         anchor: "Notebook Niches",
    //     },
    //     outbound: {
    //         top: ["lowContentBookNiches", "bestKdpNichesForBeginners", "lowCompetitionKdpNiches"],
    //         bottom: ["journalNiches", "plannerNiches", "mediumContentBookNiches", "freeToolsForAuthors"],
    //     },
    // },
    // journalNiches: {
    //     route: JOURNAL_NICHES_ROUTE,
    //     pageKey: "journalNiches",
    //     textMode: "journalNiches",
    //     labels: {
    //         top: "Start with the most relevant low-content and journal niche research pages:",
    //         bottom: "Continue exploring related low-content publishing niches:",
    //         anchor: "Journal Niches",
    //     },
    //     outbound: {
    //         top: ["lowContentBookNiches", "bestKdpNichesForBeginners", "lowCompetitionKdpNiches"],
    //         bottom: ["notebookNiches", "plannerNiches", "mediumContentBookNiches", "freeToolsForAuthors"],
    //     },
    // },
    // plannerNiches: {
    //     route: PLANNER_NICHES_ROUTE,
    //     pageKey: "plannerNiches",
    //     textMode: "plannerNiches",
    //     labels: {
    //         top: "Start with the most relevant low-content and planner niche research pages:",
    //         bottom: "Continue exploring related low-content publishing niches:",
    //         anchor: "Planner Niches",
    //     },
    //     outbound: {
    //         top: ["lowContentBookNiches", "bestKdpNichesForBeginners", "lowCompetitionKdpNiches"],
    //         bottom: ["notebookNiches", "journalNiches", "mediumContentBookNiches", "freeToolsForAuthors"],
    //     },
    // },
    // mediumContentBookNiches: {
    //     route: MEDIUM_CONTENT_BOOK_NICHES_ROUTE,
    //     pageKey: "mediumContentBookNiches",
    //     textMode: "mediumContentBookNiches",
    //     labels: {
    //         top: "Start with the most relevant medium-content and KDP niche research pages:",
    //         bottom: "Continue exploring specific medium-content niche families and related publishing opportunities:",
    //         anchor: "Medium Content Book Niches",
    //     },
    //     outbound: {
    //         top: ["kdpNicheResearch", "profitableKdpNiches", "kdpNicheResearchWithBsr"],
    //         bottom: ["puzzleBooksKdp", "sudokuBooksKdp", "lowContentBookNiches", "amazonBookNicheResearch", "freeToolsForAuthors"],
    //     },
    // },
    // puzzleBooksKdp: {
    //     route: PUZZLE_BOOKS_KDP_ROUTE,
    //     pageKey: "puzzleBooksKdp",
    //     textMode: "puzzleBooksKdp",
    //     labels: {
    //         top: "Start with the most relevant puzzle-book and medium-content niche research pages:",
    //         bottom: "Continue exploring specific puzzle-book families and related publishing opportunities:",
    //         anchor: "Puzzle Books KDP",
    //     },
    //     outbound: {
    //         top: ["mediumContentBookNiches", "profitableKdpNiches", "kdpNicheResearchWithBsr"],
    //         bottom: ["sudokuBooksKdp", "amazonBookNicheResearch", "lowCompetitionKdpNiches", "kdpNicheResearch", "freeToolsForAuthors"],
    //     },
    // },
    // sudokuBooksKdp: {
    //     route: SUDOKU_BOOKS_KDP_ROUTE,
    //     pageKey: "sudokuBooksKdp",
    //     textMode: "sudokuBooksKdp",
    //     labels: {
    //         top: "Start with the most relevant sudoku-book and puzzle niche research pages:",
    //         bottom: "Continue exploring narrower sudoku subniches and related publishing opportunities:",
    //         anchor: "Sudoku Books KDP",
    //     },
    //     outbound: {
    //         top: ["puzzleBooksKdp", "mediumContentBookNiches", "profitableKdpNiches"],
    //         bottom: ["lowCompetitionKdpNiches", "kdpNicheResearchWithBsr", "amazonBookNicheResearch", "kdpNicheResearch", "freeToolsForAuthors"],
    //     },
    // },
    // easySudokuBooksKdp: {
    //     route: EASY_SUDOKU_BOOKS_KDP_ROUTE,
    //     pageKey: "easySudokuBooksKdp",
    //     textMode: "easySudokuBooksKdp",
    //     labels: {
    //         top: "Start with the most relevant sudoku and puzzle-book niche research pages:",
    //         bottom: "Continue exploring other sudoku publishing niches:",
    //         anchor: "Easy Sudoku Books KDP",
    //     },
    //     outbound: {
    //         top: ["sudokuBooksKdp", "puzzleBooksKdp", "mediumContentBookNiches"],
    //         bottom: ["hardSudokuBooksKdp", "largePrintSudokuBooksKdp", "kidsSudokuBooksKdp", "kdpNicheResearch", "freeToolsForAuthors"],
    //     },
    // },
    // hardSudokuBooksKdp: {
    //     route: HARD_SUDOKU_BOOKS_KDP_ROUTE,
    //     pageKey: "hardSudokuBooksKdp",
    //     textMode: "hardSudokuBooksKdp",
    //     labels: {
    //         top: "Start with the most relevant sudoku and puzzle-book niche research pages:",
    //         bottom: "Continue exploring other sudoku publishing niches:",
    //         anchor: "Hard Sudoku Books KDP",
    //     },
    //     outbound: {
    //         top: ["sudokuBooksKdp", "puzzleBooksKdp", "mediumContentBookNiches"],
    //         bottom: ["easySudokuBooksKdp", "largePrintSudokuBooksKdp", "kidsSudokuBooksKdp", "kdpNicheResearch", "freeToolsForAuthors"],
    //     },
    // },
    // largePrintSudokuBooksKdp: {
    //     route: LARGE_PRINT_SUDOKU_BOOKS_KDP_ROUTE,
    //     pageKey: "largePrintSudokuBooksKdp",
    //     textMode: "largePrintSudokuBooksKdp",
    //     labels: {
    //         top: "Start with the most relevant sudoku and puzzle-book niche research pages:",
    //         bottom: "Continue exploring other sudoku publishing niches:",
    //         anchor: "Large Print Sudoku Books KDP",
    //     },
    //     outbound: {
    //         top: ["sudokuBooksKdp", "puzzleBooksKdp", "mediumContentBookNiches"],
    //         bottom: ["easySudokuBooksKdp", "hardSudokuBooksKdp", "kidsSudokuBooksKdp", "kdpNicheResearch", "freeToolsForAuthors"],
    //     },
    // },
    // kidsSudokuBooksKdp: {
    //     route: KIDS_SUDOKU_BOOKS_KDP_ROUTE,
    //     pageKey: "kidsSudokuBooksKdp",
    //     textMode: "kidsSudokuBooksKdp",
    //     labels: {
    //         top: "Start with the most relevant kids sudoku and puzzle-book niche research pages:",
    //         bottom: "Continue exploring other sudoku publishing niches:",
    //         anchor: "Kids Sudoku Books KDP",
    //     },
    //     outbound: {
    //         top: ["sudokuBooksKdp", "puzzleBooksKdp", "mediumContentBookNiches"],
    //         bottom: ["easySudokuBooksKdp", "hardSudokuBooksKdp", "largePrintSudokuBooksKdp", "kdpNicheResearch", "freeToolsForAuthors"],
    //     },
    // },

    kdpProblems: {
        route: KDP_PROBLEMS_ROUTE,
        pageKey: "kdpProblems",
        textMode: "kdpProblems",
        labels: {
            top: "Explore pages that help diagnose KDP publishing challenges:",
            bottom: "Continue with tools and guides that improve publishing results:",
            anchor: "Amazon KDP Problems",
        },
        outbound: {
            top: ["kdpEarnings", "kdpToolsHub", "amazonBsrCalc", "aiToolsForKdp", ],
            bottom: ["whyMyBookNotSelling", "whyMyKdpBookHasNoSales", "whyMyKdpBookNotShowing", "kdpBookNotIndexed",
                "kdpKeywordsNotWorking", "kdpCategoryNotShowing", "kdpBookRankingDropped", "whyAmazonRemovedMyReviews",
                "whyMyBookDisappeared", "amazonKdpAccountSuspended", "amazonKdpAccountTerminated", "amazonKdpPolicyViolations",
                "howToRecoverKdpAccount", "freeAmazonBookReviews"]
        },
    },
    // whyMyBookNotSelling: {
    //     route: WHY_MY_BOOK_NOT_SELLING_ROUTE,
    //     pageKey: "whyMyBookNotSelling",
    //     textMode: "whyMyBookNotSelling",
    //     labels: {
    //         top: "KDP Problems",
    //         bottom: "Sales Problem",
    //         anchor: "Why My Book Is Not Selling"
    //     },
    //     outbound: {
    //         top: [
    //             "kdpProblems",
    //             "whyMyKdpBookHasNoSales",
    //             "howToIncreaseAmazonBookSales"
    //         ],
    //         bottom: [
    //             "whyMyKdpBookNotShowingOnAmazon",
    //             "kdpBookNotIndexed",
    //             "kdpKeywordsNotWorking"
    //         ]
    //     },
    //
    // },
    // whyMyKdpBookHasNoSales: {
    //     route: WHY_MY_KDP_BOOK_HAS_NO_SALES_ROUTE,
    //     pageKey: "whyMyKdpBookHasNoSales",
    //     textMode: "whyMyKdpBookHasNoSales",
    //     labels: {
    //         top: "KDP Problems",
    //         bottom: "No Sales",
    //         anchor: "Why My KDP Book Has No Sales"
    //     },
    //     outbound: {
    //         top: [
    //             "kdpProblems",
    //             "whyMyBookNotSelling",
    //             "howToIncreaseAmazonBookSales"
    //         ],
    //         bottom: [
    //             "whyMyKdpBookNotShowingOnAmazon",
    //             "kdpBookNotIndexed",
    //             "kdpKeywordsNotWorking"
    //         ]
    //     },
    // },
    // howToIncreaseAmazonBookSales: {
    //     route: HOW_TO_INCREASE_AMAZON_BOOK_SALES_ROUTE,
    //     pageKey: "howToIncreaseAmazonBookSales",
    //     textMode: "howToIncreaseAmazonBookSales",
    //     labels: {
    //         top: "KDP Problems",
    //         bottom: "Sales Growth",
    //         anchor: "Increase Amazon Book Sales"
    //     },
    //     outbound: {
    //
    //         top: [
    //             "kdpProblems",
    //             "whyMyBookNotSelling",
    //             "whyMyKdpBookHasNoSales"
    //         ],
    //         bottom: [
    //             "kdpKeywordsNotWorking",
    //             "kdpCategoryNotShowing",
    //             "kdpBookRankingDropped"
    //         ]
    //     },
    //
    // },
    // whyMyKdpBookNotShowing: {
    //     route: WHY_MY_KDP_BOOK_NOT_SHOWING_ROUTE,
    //     pageKey: "whyMyKdpBookNotShowing",
    //     textMode: "whyMyKdpBookNotShowing",
    //     labels: {
    //         top: "KDP Problems",
    //         bottom: "Visibility Problem",
    //         anchor: "Why My KDP Book Is Not Showing"
    //     },
    //     outbound: {
    //         top: [
    //             "kdpProblems",
    //             "kdpBookNotIndexed",
    //             "howToFixKdpIndexing"
    //         ],
    //         bottom: [
    //             "whyMyBookDisappearedFromAmazon",
    //             "kdpKeywordsNotWorking",
    //             "kdpCategoryNotShowing"
    //         ]
    //     },
    // },
    // kdpBookNotIndexed: {
    //     route: KDP_BOOK_NOT_INDEXED_ROUTE,
    //     pageKey: "kdpBookNotIndexed",
    //     textMode: "kdpBookNotIndexed",
    //     labels: {
    //         top: "KDP Problems",
    //         bottom: "Indexing Problem",
    //         anchor: "KDP Book Not Indexed"
    //     },
    //     outbound: {
    //         top: [
    //             "kdpProblems",
    //             "whyMyKdpBookNotShowing",
    //             "howToFixKdpIndexing"
    //         ],
    //         bottom: [
    //             "kdpKeywordsNotWorking",
    //             "kdpCategoryNotShowing",
    //             "whyMyBookDisappearedFromAmazon"
    //         ]
    //     },
    // },
    // howToFixKdpIndexing: {
    //     route: HOW_TO_FIX_KDP_INDEXING_ROUTE,
    //     pageKey: "howToFixKdpIndexing",
    //     textMode: "howToFixKdpIndexing",
    //     labels: {
    //         top: "KDP Problems",
    //         bottom: "Fix Indexing",
    //         anchor: "How to Fix KDP Indexing"
    //     },
    //     outbound: {
    //         top: [
    //             "kdpProblems",
    //             "kdpBookNotIndexed",
    //             "whyMyKdpBookNotShowing"
    //         ],
    //         bottom: [
    //             "kdpKeywordsNotWorking",
    //             "kdpCategoryNotShowing",
    //             "kdpBookRankingDropped"
    //         ]
    //     },
    // },
    // whyMyBookDisappeared: {
    //     route: WHY_MY_BOOK_DISAPPEARED_ROUTE,
    //     pageKey: "whyMyBookDisappeared",
    //     textMode: "whyMyBookDisappeared",
    //     labels: {
    //         top: "KDP Problems",
    //         bottom: "Book Disappeared",
    //         anchor: "Why My Book Disappeared"
    //     },
    //     outbound: {
    //         top: [
    //             "kdpProblems",
    //             "whyMyKdpBookNotShowing",
    //             "kdpBookNotIndexed"
    //         ],
    //         bottom: [
    //             "howToFixKdpIndexing",
    //             "amazonKdpAccountSuspended",
    //             "amazonKdpPolicyViolations"
    //         ]
    //     },
    // },
    // amazonKdpAccountSuspended: {
    //     route: AMAZON_KDP_ACCOUNT_SUSPENDED_ROUTE,
    //     pageKey: "amazonKdpAccountSuspended",
    //     textMode: "amazonKdpAccountSuspended",
    //     labels: {
    //         top: "KDP Problems",
    //         bottom: "Account Suspension",
    //         anchor: "Amazon KDP Account Suspended"
    //     },
    //     outbound: {
    //         top: [
    //             "kdpProblems",
    //             "amazonKdpAccountTerminated",
    //             "howToRecoverKdpAccount"
    //         ],
    //         bottom: [
    //             "amazonKdpPolicyViolations",
    //             "whyMyBookDisappeared",
    //             "whyAmazonRemovedMyReviews"
    //         ]
    //     },
    // },
    // amazonKdpAccountTerminated: {
    //     route: AMAZON_KDP_ACCOUNT_TERMINATED_ROUTE,
    //     pageKey: "amazonKdpAccountTerminated",
    //     textMode: "amazonKdpAccountTerminated",
    //     labels: {
    //         top: "KDP Problems",
    //         bottom: "Account Termination",
    //         anchor: "Amazon KDP Account Terminated"
    //     },
    //     outbound: {
    //         top: [
    //             "kdpProblems",
    //             "amazonKdpAccountSuspended",
    //             "howToRecoverKdpAccount"
    //         ],
    //         bottom: [
    //             "amazonKdpPolicyViolations",
    //             "whyMyBookDisappeared",
    //             "whyAmazonRemovedMyReviews"
    //         ]
    //     },
    // },
    // howToRecoverKdpAccount: {
    //     route: HOW_TO_RECOVER_KDP_ACCOUNT_ROUTE,
    //     pageKey: "howToRecoverKdpAccount",
    //     textMode: "howToRecoverKdpAccount",
    //     labels: {
    //         top: "KDP Problems",
    //         bottom: "Account Recovery",
    //         anchor: "How to Recover a KDP Account"
    //     },
    //     outbound: {
    //         top: [
    //             "kdpProblems",
    //             "amazonKdpAccountSuspended",
    //             "amazonKdpAccountTerminated"
    //         ],
    //         bottom: [
    //             "amazonKdpPolicyViolations",
    //             "whyMyBookDisappeared",
    //             "whyAmazonRemovedMyReviews"
    //         ]
    //     },
    // },
    // amazonKdpPolicyViolations: {
    //     route: AMAZON_KDP_POLICY_VIOLATIONS_ROUTE,
    //     pageKey: "amazonKdpPolicyViolations",
    //     textMode: "amazonKdpPolicyViolations",
    //     labels: {
    //         top: "KDP Problems",
    //         bottom: "Policy Violations",
    //         anchor: "Amazon KDP Policy Violations"
    //     },
    //     outbound: {
    //         top: [
    //             "kdpProblems",
    //             "amazonKdpAccountSuspended",
    //             "amazonKdpAccountTerminated"
    //         ],
    //         bottom: [
    //             "howToRecoverKdpAccount",
    //             "whyMyBookDisappeared",
    //             "whyAmazonRemovedMyReviews"
    //         ]
    //     },
    // },
    // kdpKeywordsNotWorking: {
    //     route: KDP_KEYWORDS_NOT_WORKING_ROUTE,
    //     pageKey: "kdpKeywordsNotWorking",
    //     textMode: "kdpKeywordsNotWorking",
    //     labels: {
    //         top: "KDP Problems",
    //         bottom: "Keyword Problem",
    //         anchor: "KDP Keywords Not Working"
    //     },
    //     outbound: {
    //         top: [
    //             "kdpProblems",
    //             "kdpBookNotIndexed",
    //             "kdpCategoryNotShowing"
    //         ],
    //         bottom: [
    //             "howToFixKdpIndexing",
    //             "kdpBookRankingDropped",
    //             "howToIncreaseAmazonBookSales"
    //         ]
    //     },
    // },
    // kdpCategoryNotShowing: {
    //     route: KDP_CATEGORY_NOT_SHOWING_ROUTE,
    //     pageKey: "kdpCategoryNotShowing",
    //     textMode: "kdpCategoryNotShowing",
    //     labels: {
    //         top: "KDP Problems",
    //         bottom: "Category Problem",
    //         anchor: "KDP Category Not Showing"
    //     },
    //     outbound: {
    //         top: [
    //             "kdpProblems",
    //             "kdpKeywordsNotWorking",
    //             "kdpBookNotIndexed"
    //         ],
    //         bottom: [
    //             "howToIncreaseAmazonBookSales",
    //             "kdpBookRankingDropped",
    //             "howToFixKdpIndexing"
    //         ]
    //     },
    // },
    // kdpBookRankingDropped: {
    //     route: KDP_BOOK_RANKING_DROPPED_ROUTE,
    //     pageKey: "kdpBookRankingDropped",
    //     textMode: "kdpBookRankingDropped",
    //
    //     labels: {
    //         top: "KDP Problems",
    //         bottom: "Ranking Drop",
    //         anchor: "KDP Book Ranking Dropped"
    //     },
    //     outbound: {
    //         top: [
    //             "kdpProblems",
    //             "kdpKeywordsNotWorking",
    //             "kdpCategoryNotShowing"
    //         ],
    //         bottom: [
    //             "howToIncreaseAmazonBookSales",
    //             "howAmazonBsrTranslatesToSales",
    //             "kdpIncomeCalculator"
    //         ]
    //     },
    // },
    // whyAmazonRemovedMyReviews: {
    //     route: WHY_AMAZON_REMOVED_MY_REVIEWS_ROUTE,
    //     pageKey: "whyAmazonRemovedMyReviews",
    //     textMode: "whyAmazonRemovedMyReviews",
    //     labels: {
    //         top: "KDP Problems",
    //         bottom: "Review Problem",
    //         anchor: "Why Amazon Removed My Reviews"
    //     },
    //     outbound: {
    //         top: [
    //             "kdpProblems",
    //             "amazonKdpPolicyViolations",
    //             "amazonKdpAccountSuspended"
    //         ],
    //         bottom: [
    //             "howToRecoverKdpAccount",
    //             "whyMyBookDisappeared",
    //             "howToIncreaseAmazonBookSales"
    //         ]
    //     },
    // },

    kdpDiscoverability: {
        route: KDP_DISCOVERABILITY_ROUTE,
        labels: {
            top: "Explore pages that help improve book discoverability:",
            bottom: "Continue with related KDP tools and publishing guides:",
            anchor: "KDP Discoverability",
        },
        outbound: {
            top: [
                "getAmazonBookReviews", "kdpNicheResearch",
                "howAmazonKeywordsRankingWorks",
                "howAmazonBookCategoriesWork",
                "amazonBookRankingFactors"
            ],
            bottom: [
                "howAmazonBookRankingWorks",
                "howToRankBooksOnAmazon",
                "howToGetBookDiscovered",
                "howAmazonKdpAlgorithmWorks",
                "amazonBookRankingFactors",
                "amazonBsrVsDiscoverability",
                "howAmazonKeywordsRankingWorks",
                "howToRankForAmazonKeywords",
                "amazonKdpKeywordStrategy",
                "howAmazonBookCategoriesWork",
                "howToRankInAmazonCategories",
                "kdpCategoryStrategy",
                "howReviewsAffectRanking",
                "howClicksAffectAmazonRanking",
                "howSalesAffectAmazonRanking",
                "kdpNicheResearch",
            ]
        },
    },
    // howAmazonBookRankingWorks: {
    //     route: HOW_AMAZON_BOOK_RANKING_WORKS_ROUTE,
    //     labels: {
    //         top: "Explore pages that explain how Amazon ranking and discoverability work for books:",
    //         bottom: "Continue with related pages about keywords, categories, sales, clicks, and KDP discoverability:",
    //         anchor: "How Amazon Book Ranking Works",
    //     },
    //     outbound: {
    //         top: [
    //             "kdpDiscoverability",
    //             "howToRankBooksOnAmazon",
    //             "howAmazonKdpAlgorithmWorks",
    //             "amazonBookRankingFactors",
    //             "amazonBsrVsDiscoverability"
    //         ],
    //         bottom: [
    //             "kdpDiscoverability",
    //             "howToRankBooksOnAmazon",
    //             "howToGetBookDiscovered",
    //             "howAmazonKdpAlgorithmWorks",
    //             "amazonBookRankingFactors",
    //             "amazonBsrVsDiscoverability",
    //             "howAmazonKeywordsRankingWorks",
    //             "howToRankForAmazonKeywords",
    //             "amazonKdpKeywordStrategy",
    //             "howAmazonBookCategoriesWork",
    //             "howToRankInAmazonCategories",
    //             "kdpCategoryStrategy",
    //             "howReviewsAffectRanking",
    //             "howClicksAffectAmazonRanking",
    //             "howSalesAffectAmazonRanking"
    //         ]
    //     },
    // },
    // howToRankBooksOnAmazon: {
    //     route: HOW_TO_RANK_BOOKS_ON_AMAZON_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors improve Amazon book ranking and discoverability:",
    //         bottom: "Continue with related pages about keywords, categories, sales, clicks, and KDP visibility:",
    //         anchor: "How to Rank Books on Amazon",
    //     },
    //     outbound: {
    //         top: [
    //             "kdpDiscoverability",
    //             "howAmazonBookRankingWorks",
    //             "howToGetBookDiscovered",
    //             "amazonBookRankingFactors",
    //             "howAmazonKdpAlgorithmWorks"
    //         ],
    //         bottom: [
    //             "kdpDiscoverability",
    //             "howAmazonBookRankingWorks",
    //             "howToGetBookDiscovered",
    //             "howAmazonKdpAlgorithmWorks",
    //             "amazonBookRankingFactors",
    //             "amazonBsrVsDiscoverability",
    //             "howAmazonKeywordsRankingWorks",
    //             "howToRankForAmazonKeywords",
    //             "amazonKdpKeywordStrategy",
    //             "howAmazonBookCategoriesWork",
    //             "howToRankInAmazonCategories",
    //             "kdpCategoryStrategy",
    //             "howReviewsAffectRanking",
    //             "howClicksAffectAmazonRanking",
    //             "howSalesAffectAmazonRanking"
    //         ]
    //     },
    // },
    // howToGetBookDiscovered: {
    //     route: HOW_TO_GET_BOOK_DISCOVERED_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors improve Amazon book discoverability and visibility:",
    //         bottom: "Continue with related pages about ranking, keywords, categories, clicks, and sales signals:",
    //         anchor: "How to Get a Book Discovered",
    //     },
    //     outbound: {
    //         top: [
    //             "kdpDiscoverability",
    //             "howAmazonBookRankingWorks",
    //             "howToRankBooksOnAmazon",
    //             "amazonBookRankingFactors",
    //             "howAmazonKdpAlgorithmWorks"
    //         ],
    //         bottom: [
    //             "kdpDiscoverability",
    //             "howAmazonBookRankingWorks",
    //             "howToRankBooksOnAmazon",
    //             "howAmazonKdpAlgorithmWorks",
    //             "amazonBookRankingFactors",
    //             "amazonBsrVsDiscoverability",
    //             "howAmazonKeywordsRankingWorks",
    //             "howToRankForAmazonKeywords",
    //             "amazonKdpKeywordStrategy",
    //             "howAmazonBookCategoriesWork",
    //             "howToRankInAmazonCategories",
    //             "kdpCategoryStrategy",
    //             "howReviewsAffectRanking",
    //             "howClicksAffectAmazonRanking",
    //             "howSalesAffectAmazonRanking"
    //         ]
    //     },
    // },
    // howAmazonKdpAlgorithmWorks: {
    //     route: HOW_AMAZON_KDP_ALGORITHM_WORKS_ROUTE,
    //     labels: {
    //         top: "Explore pages that explain how the Amazon KDP algorithm affects discoverability and visibility:",
    //         bottom: "Continue with related pages about ranking, keywords, categories, clicks, and sales signals:",
    //         anchor: "How Amazon KDP Algorithm Works",
    //     },
    //     outbound: {
    //         top: [
    //             "kdpDiscoverability",
    //             "howAmazonBookRankingWorks",
    //             "howToRankBooksOnAmazon",
    //             "howToGetBookDiscovered",
    //             "amazonBookRankingFactors"
    //         ],
    //         bottom: [
    //             "kdpDiscoverability",
    //             "howAmazonBookRankingWorks",
    //             "howToRankBooksOnAmazon",
    //             "howToGetBookDiscovered",
    //             "amazonBookRankingFactors",
    //             "amazonBsrVsDiscoverability",
    //             "howAmazonKeywordsRankingWorks",
    //             "howToRankForAmazonKeywords",
    //             "amazonKdpKeywordStrategy",
    //             "howAmazonBookCategoriesWork",
    //             "howToRankInAmazonCategories",
    //             "kdpCategoryStrategy",
    //             "howReviewsAffectRanking",
    //             "howClicksAffectAmazonRanking",
    //             "howSalesAffectAmazonRanking"
    //         ]
    //     },
    // },
    // amazonBookRankingFactors: {
    //     route: AMAZON_BOOK_RANKING_FACTORS_ROUTE,
    //     labels: {
    //         top: "Explore pages that explain which factors influence Amazon book ranking and discoverability:",
    //         bottom: "Continue with related pages about keywords, categories, clicks, sales, and KDP visibility strategy:",
    //         anchor: "Amazon Book Ranking Factors",
    //     },
    //     outbound: {
    //         top: [
    //             "kdpDiscoverability",
    //             "howAmazonBookRankingWorks",
    //             "howToRankBooksOnAmazon",
    //             "howAmazonKdpAlgorithmWorks",
    //             "amazonBsrVsDiscoverability"
    //         ],
    //         bottom: [
    //             "kdpDiscoverability",
    //             "howAmazonBookRankingWorks",
    //             "howToRankBooksOnAmazon",
    //             "howToGetBookDiscovered",
    //             "howAmazonKdpAlgorithmWorks",
    //             "amazonBsrVsDiscoverability",
    //             "howAmazonKeywordsRankingWorks",
    //             "howToRankForAmazonKeywords",
    //             "amazonKdpKeywordStrategy",
    //             "howAmazonBookCategoriesWork",
    //             "howToRankInAmazonCategories",
    //             "kdpCategoryStrategy",
    //             "howReviewsAffectRanking",
    //             "howClicksAffectAmazonRanking",
    //             "howSalesAffectAmazonRanking"
    //         ]
    //     },
    // },
    // amazonBsrVsDiscoverability: {
    //     route: AMAZON_BSR_VS_DISCOVERABILITY_ROUTE,
    //     labels: {
    //         top: "Explore pages that explain the difference between Amazon BSR and discoverability:",
    //         bottom: "Continue with related pages about ranking, keywords, categories, clicks, and sales signals:",
    //         anchor: "Amazon BSR vs Discoverability",
    //     },
    //     outbound: {
    //         top: [
    //             "kdpDiscoverability",
    //             "howAmazonBookRankingWorks",
    //             "howToRankBooksOnAmazon",
    //             "howAmazonKdpAlgorithmWorks",
    //             "amazonBookRankingFactors"
    //         ],
    //         bottom: [
    //             "kdpDiscoverability",
    //             "howAmazonBookRankingWorks",
    //             "howToRankBooksOnAmazon",
    //             "howToGetBookDiscovered",
    //             "howAmazonKdpAlgorithmWorks",
    //             "amazonBookRankingFactors",
    //             "howAmazonKeywordsRankingWorks",
    //             "howToRankForAmazonKeywords",
    //             "amazonKdpKeywordStrategy",
    //             "howAmazonBookCategoriesWork",
    //             "howToRankInAmazonCategories",
    //             "kdpCategoryStrategy",
    //             "howReviewsAffectRanking",
    //             "howClicksAffectAmazonRanking",
    //             "howSalesAffectAmazonRanking"
    //         ]
    //     },
    // },
    // howAmazonKeywordsRankingWorks: {
    //     route: HOW_AMAZON_KEYWORDS_RANKING_WORKS_ROUTE,
    //     labels: {
    //         top: "Explore pages that explain how keyword ranking affects Amazon book discoverability:",
    //         bottom: "Continue with related pages about search visibility, categories, clicks, sales, and KDP discoverability:",
    //         anchor: "How Amazon Keywords Ranking Works",
    //     },
    //     outbound: {
    //         top: [
    //             "kdpDiscoverability",
    //             "howAmazonBookRankingWorks",
    //             "howToRankForAmazonKeywords",
    //             "amazonKdpKeywordStrategy",
    //             "howToRankBooksOnAmazon"
    //         ],
    //         bottom: [
    //             "kdpDiscoverability",
    //             "howAmazonBookRankingWorks",
    //             "howToRankBooksOnAmazon",
    //             "howToGetBookDiscovered",
    //             "howAmazonKdpAlgorithmWorks",
    //             "amazonBookRankingFactors",
    //             "amazonBsrVsDiscoverability",
    //             "howToRankForAmazonKeywords",
    //             "amazonKdpKeywordStrategy",
    //             "howAmazonBookCategoriesWork",
    //             "howToRankInAmazonCategories",
    //             "kdpCategoryStrategy",
    //             "howReviewsAffectRanking",
    //             "howClicksAffectAmazonRanking",
    //             "howSalesAffectAmazonRanking"
    //         ]
    //     },
    // },
    // howToRankForAmazonKeywords: {
    //     route: HOW_TO_RANK_FOR_AMAZON_KEYWORDS_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors improve keyword ranking and Amazon search visibility:",
    //         bottom: "Continue with related pages about search relevance, categories, clicks, sales, and KDP discoverability:",
    //         anchor: "How to Rank for Amazon Keywords",
    //     },
    //     outbound: {
    //         top: [
    //             "kdpDiscoverability",
    //             "howAmazonKeywordsRankingWorks",
    //             "amazonKdpKeywordStrategy",
    //             "howToRankBooksOnAmazon",
    //             "howAmazonBookRankingWorks"
    //         ],
    //         bottom: [
    //             "kdpDiscoverability",
    //             "howAmazonBookRankingWorks",
    //             "howToRankBooksOnAmazon",
    //             "howToGetBookDiscovered",
    //             "howAmazonKdpAlgorithmWorks",
    //             "amazonBookRankingFactors",
    //             "amazonBsrVsDiscoverability",
    //             "howAmazonKeywordsRankingWorks",
    //             "amazonKdpKeywordStrategy",
    //             "howAmazonBookCategoriesWork",
    //             "howToRankInAmazonCategories",
    //             "kdpCategoryStrategy",
    //             "howReviewsAffectRanking",
    //             "howClicksAffectAmazonRanking",
    //             "howSalesAffectAmazonRanking"
    //         ]
    //     },
    // },
    // amazonKdpKeywordStrategy: {
    //     route: AMAZON_KDP_KEYWORD_STRATEGY_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors build a stronger Amazon KDP keyword strategy:",
    //         bottom: "Continue with related pages about search visibility, ranking, categories, clicks, and discoverability:",
    //         anchor: "Amazon KDP Keyword Strategy",
    //     },
    //     outbound: {
    //         top: [
    //             "kdpDiscoverability",
    //             "howAmazonKeywordsRankingWorks",
    //             "howToRankForAmazonKeywords",
    //             "howToRankBooksOnAmazon",
    //             "howAmazonBookRankingWorks"
    //         ],
    //         bottom: [
    //             "kdpDiscoverability",
    //             "howAmazonBookRankingWorks",
    //             "howToRankBooksOnAmazon",
    //             "howToGetBookDiscovered",
    //             "howAmazonKdpAlgorithmWorks",
    //             "amazonBookRankingFactors",
    //             "amazonBsrVsDiscoverability",
    //             "howAmazonKeywordsRankingWorks",
    //             "howToRankForAmazonKeywords",
    //             "howAmazonBookCategoriesWork",
    //             "howToRankInAmazonCategories",
    //             "kdpCategoryStrategy",
    //             "howReviewsAffectRanking",
    //             "howClicksAffectAmazonRanking",
    //             "howSalesAffectAmazonRanking"
    //         ]
    //     },
    // },
    // howAmazonBookCategoriesWork: {
    //     route: HOW_AMAZON_BOOK_CATEGORIES_WORK_ROUTE,
    //     labels: {
    //         top: "Explore pages that explain how Amazon book categories affect discoverability and ranking:",
    //         bottom: "Continue with related pages about keyword visibility, category strategy, clicks, sales, and KDP discoverability:",
    //         anchor: "How Amazon Book Categories Work",
    //     },
    //     outbound: {
    //         top: [
    //             "kdpDiscoverability",
    //             "howToRankInAmazonCategories",
    //             "kdpCategoryStrategy",
    //             "howToRankBooksOnAmazon",
    //             "howAmazonBookRankingWorks"
    //         ],
    //         bottom: [
    //             "kdpDiscoverability",
    //             "howAmazonBookRankingWorks",
    //             "howToRankBooksOnAmazon",
    //             "howToGetBookDiscovered",
    //             "howAmazonKdpAlgorithmWorks",
    //             "amazonBookRankingFactors",
    //             "amazonBsrVsDiscoverability",
    //             "howAmazonKeywordsRankingWorks",
    //             "howToRankForAmazonKeywords",
    //             "amazonKdpKeywordStrategy",
    //             "howToRankInAmazonCategories",
    //             "kdpCategoryStrategy",
    //             "howReviewsAffectRanking",
    //             "howClicksAffectAmazonRanking",
    //             "howSalesAffectAmazonRanking"
    //         ]
    //     },
    // },
    // howToRankInAmazonCategories: {
    //     route: HOW_TO_RANK_IN_AMAZON_CATEGORIES_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors improve ranking and discoverability inside Amazon categories:",
    //         bottom: "Continue with related pages about category strategy, keyword visibility, clicks, sales, and KDP discoverability:",
    //         anchor: "How to Rank in Amazon Categories",
    //     },
    //     outbound: {
    //         top: [
    //             "kdpDiscoverability",
    //             "howAmazonBookCategoriesWork",
    //             "kdpCategoryStrategy",
    //             "howToRankBooksOnAmazon",
    //             "howAmazonBookRankingWorks"
    //         ],
    //         bottom: [
    //             "kdpDiscoverability",
    //             "howAmazonBookRankingWorks",
    //             "howToRankBooksOnAmazon",
    //             "howToGetBookDiscovered",
    //             "howAmazonKdpAlgorithmWorks",
    //             "amazonBookRankingFactors",
    //             "amazonBsrVsDiscoverability",
    //             "howAmazonKeywordsRankingWorks",
    //             "howToRankForAmazonKeywords",
    //             "amazonKdpKeywordStrategy",
    //             "howAmazonBookCategoriesWork",
    //             "kdpCategoryStrategy",
    //             "howReviewsAffectRanking",
    //             "howClicksAffectAmazonRanking",
    //             "howSalesAffectAmazonRanking"
    //         ]
    //     },
    // },
    // kdpCategoryStrategy: {
    //     route: KDP_CATEGORY_STRATEGY_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors build stronger category strategy for discoverability:",
    //         bottom: "Continue with related pages about category ranking, keywords, clicks, sales, and KDP visibility:",
    //         anchor: "KDP Category Strategy",
    //     },
    //     outbound: {
    //         top: [
    //             "kdpDiscoverability",
    //             "howAmazonBookCategoriesWork",
    //             "howToRankInAmazonCategories",
    //             "howToRankBooksOnAmazon",
    //             "howAmazonBookRankingWorks"
    //         ],
    //         bottom: [
    //             "kdpDiscoverability",
    //             "howAmazonBookRankingWorks",
    //             "howToRankBooksOnAmazon",
    //             "howToGetBookDiscovered",
    //             "howAmazonKdpAlgorithmWorks",
    //             "amazonBookRankingFactors",
    //             "amazonBsrVsDiscoverability",
    //             "howAmazonKeywordsRankingWorks",
    //             "howToRankForAmazonKeywords",
    //             "amazonKdpKeywordStrategy",
    //             "howAmazonBookCategoriesWork",
    //             "howToRankInAmazonCategories",
    //             "howReviewsAffectRanking",
    //             "howClicksAffectAmazonRanking",
    //             "howSalesAffectAmazonRanking"
    //         ]
    //     },
    // },
    // howReviewsAffectRanking: {
    //     route: HOW_REVIEWS_AFFECT_RANKING_ROUTE,
    //     labels: {
    //         top: "Explore pages that explain how reviews influence ranking, trust, and discoverability:",
    //         bottom: "Continue with related pages about clicks, sales, keywords, categories, and KDP visibility:",
    //         anchor: "How Reviews Affect Ranking",
    //     },
    //     outbound: {
    //         top: [
    //             "kdpDiscoverability",
    //             "howAmazonBookRankingWorks",
    //             "howToGetBookDiscovered",
    //             "howClicksAffectAmazonRanking",
    //             "howSalesAffectAmazonRanking"
    //         ],
    //         bottom: [
    //             "kdpDiscoverability",
    //             "howAmazonBookRankingWorks",
    //             "howToRankBooksOnAmazon",
    //             "howToGetBookDiscovered",
    //             "howAmazonKdpAlgorithmWorks",
    //             "amazonBookRankingFactors",
    //             "amazonBsrVsDiscoverability",
    //             "howAmazonKeywordsRankingWorks",
    //             "howToRankForAmazonKeywords",
    //             "amazonKdpKeywordStrategy",
    //             "howAmazonBookCategoriesWork",
    //             "howToRankInAmazonCategories",
    //             "kdpCategoryStrategy",
    //             "howClicksAffectAmazonRanking",
    //             "howSalesAffectAmazonRanking"
    //         ]
    //     },
    // },
    // howClicksAffectAmazonRanking: {
    //     route: HOW_CLICKS_AFFECT_AMAZON_RANKING_ROUTE,
    //     labels: {
    //         top: "Explore pages that explain how clicks influence Amazon ranking and discoverability:",
    //         bottom: "Continue with related pages about reviews, sales, keywords, categories, and KDP visibility:",
    //         anchor: "How Clicks Affect Amazon Ranking",
    //     },
    //     outbound: {
    //         top: [
    //             "kdpDiscoverability",
    //             "howAmazonBookRankingWorks",
    //             "howReviewsAffectRanking",
    //             "howSalesAffectAmazonRanking",
    //             "howToGetBookDiscovered"
    //         ],
    //         bottom: [
    //             "kdpDiscoverability",
    //             "howAmazonBookRankingWorks",
    //             "howToRankBooksOnAmazon",
    //             "howToGetBookDiscovered",
    //             "howAmazonKdpAlgorithmWorks",
    //             "amazonBookRankingFactors",
    //             "amazonBsrVsDiscoverability",
    //             "howAmazonKeywordsRankingWorks",
    //             "howToRankForAmazonKeywords",
    //             "amazonKdpKeywordStrategy",
    //             "howAmazonBookCategoriesWork",
    //             "howToRankInAmazonCategories",
    //             "kdpCategoryStrategy",
    //             "howReviewsAffectRanking",
    //             "howSalesAffectAmazonRanking"
    //         ]
    //     },
    // },
    // howSalesAffectAmazonRanking: {
    //     route: HOW_SALES_AFFECT_AMAZON_RANKING_ROUTE,
    //     labels: {
    //         top: "Explore pages that explain how sales influence Amazon ranking and discoverability:",
    //         bottom: "Continue with related pages about clicks, reviews, keywords, categories, and KDP visibility:",
    //         anchor: "How Sales Affect Amazon Ranking",
    //     },
    //     outbound: {
    //         top: [
    //             "kdpDiscoverability",
    //             "howAmazonBookRankingWorks",
    //             "howClicksAffectAmazonRanking",
    //             "howReviewsAffectRanking",
    //             "howToGetBookDiscovered"
    //         ],
    //         bottom: [
    //             "kdpDiscoverability",
    //             "howAmazonBookRankingWorks",
    //             "howToRankBooksOnAmazon",
    //             "howToGetBookDiscovered",
    //             "howAmazonKdpAlgorithmWorks",
    //             "amazonBookRankingFactors",
    //             "amazonBsrVsDiscoverability",
    //             "howAmazonKeywordsRankingWorks",
    //             "howToRankForAmazonKeywords",
    //             "amazonKdpKeywordStrategy",
    //             "howAmazonBookCategoriesWork",
    //             "howToRankInAmazonCategories",
    //             "kdpCategoryStrategy",
    //             "howReviewsAffectRanking",
    //             "howClicksAffectAmazonRanking"
    //         ]
    //     },
    // },

    bookMarketing: {
        route: BOOK_MARKETING_ROUTE,
        labels: {
            top: "Explore pages that help improve book marketing strategy:",
            bottom: "Continue with related KDP tools and publishing guides:",
            anchor: "Book Marketing",
        },
        outbound: {

            top: ["kdpEarnings", "kdpNicheResearch", "amazonAdsForBooks", "kdpToolsHub", "howToMarketABook",
                "bookMarketingStrategyForSelfPublishedAuthors", "bookLaunchStrategyAmazon",
                "freeBookMarketingStrategies"
            ],

            bottom: ["howToMarketABook", "howToPromoteABookOnAmazon", "bookLaunchStrategyAmazon", "bookLaunchChecklist",
                "amazonAdsForBooks", "kdpToolsHub", "getAmazonBookReviews",
                "howToGetFirstBookSales", "freeBookMarketingStrategies", "freeBookPromotionSites", "bookPromotionEmailLists",
                "bestBookPromotionSites", "kindleBookPromotionSites", "arcReadersForBooks", "howToBuildArcTeam",
                "howToGetBookReviewsBeforeLaunch", "howToBuildAuthorPlatform", "emailListForAuthors", "howToPromoteBookOnSocialMedia",
                "howToPromoteBookOnFacebook", "howToPromoteBookOnTikTok", "bookMarketingChecklist",
                "bookMarketingStrategyForSelfPublishedAuthors",
            ]

        },
    },
    // howToMarketABook: {
    //     route: HOW_TO_MARKET_A_BOOK_ROUTE,
    //     pageKey: "howToMarketABook",
    //     textMode: "howToMarketABook",
    //     labels: {
    //         top: "Start with the core pages that explain how authors market books effectively:",
    //         bottom: "Continue with related book launch, promotion, review, and audience-building pages:",
    //         anchor: "How to Market a Book",
    //     },
    //     outbound: {
    //         top: [
    //             "bookMarketing",
    //             "bookMarketingStrategyForSelfPublishedAuthors",
    //             "bookLaunchStrategyAmazon",
    //             "howToPromoteABookOnAmazon",
    //             "freeBookMarketingStrategies"
    //         ],
    //         bottom: [
    //             "bookMarketing",
    //             "howToPromoteABookOnAmazon",
    //             "bookLaunchStrategyAmazon",
    //             "bookLaunchChecklist",
    //             "howToGetFirstBookSales",
    //             "freeBookMarketingStrategies",
    //             "freeBookPromotionSites",
    //             "bookPromotionEmailLists",
    //             "bestBookPromotionSites",
    //             "kindleBookPromotionSites",
    //             "arcReadersForBooks",
    //             "howToBuildArcTeam",
    //             "howToGetBookReviewsBeforeLaunch",
    //             "howToBuildAuthorPlatform",
    //             "emailListForAuthors",
    //             "howToPromoteBookOnSocialMedia",
    //             "bookMarketingChecklist",
    //             "bookMarketingStrategyForSelfPublishedAuthors"
    //         ]
    //     },
    // },
    // howToPromoteABookOnAmazon: {
    //     route: HOW_TO_PROMOTE_A_BOOK_ON_AMAZON_ROUTE,
    //     labels: {
    //         top: "Explore pages that explain how to promote books directly inside Amazon:",
    //         bottom: "Continue with related book launch, marketing, and reader growth guides:",
    //         anchor: "Promote a Book on Amazon",
    //     },
    //     outbound: {
    //
    //         top: [
    //             "bookMarketing",
    //             "howToMarketABook",
    //             "bookLaunchStrategyAmazon",
    //             "amazonAdsForBooks",
    //             "freeBookMarketingStrategies"
    //         ],
    //
    //         bottom: [
    //             "howToMarketABook",
    //             "bookLaunchStrategyAmazon",
    //             "bookLaunchChecklist",
    //             "howToGetFirstBookSales",
    //             "amazonAdsForBooks",
    //             "freeBookMarketingStrategies",
    //             "freeBookPromotionSites",
    //             "bookPromotionEmailLists",
    //             "bestBookPromotionSites",
    //             "kindleBookPromotionSites",
    //             "arcReadersForBooks",
    //             "howToBuildArcTeam",
    //             "howToGetBookReviewsBeforeLaunch",
    //             "emailListForAuthors",
    //             "howToPromoteBookOnSocialMedia",
    //             "howToPromoteBookOnFacebook",
    //             "howToPromoteBookOnTikTok",
    //             "bookMarketingChecklist"
    //         ]
    //
    //     },
    //
    //
    // },
    // bookLaunchStrategyAmazon: {
    //     route: BOOK_LAUNCH_STRATEGY_AMAZON_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors plan a stronger Amazon book launch:",
    //         bottom: "Continue with related launch, promotion, reviews, and audience-building pages:",
    //         anchor: "Book Launch Strategy Amazon",
    //     },
    //     outbound: {
    //         top: [
    //             "bookMarketing",
    //             "howToMarketABook",
    //             "howToPromoteABookOnAmazon",
    //             "bookLaunchChecklist",
    //             "howToGetBookReviewsBeforeLaunch"
    //         ],
    //         bottom: [
    //             "bookMarketing",
    //             "howToMarketABook",
    //             "howToPromoteABookOnAmazon",
    //             "bookLaunchChecklist",
    //             "howToGetFirstBookSales",
    //             "freeBookMarketingStrategies",
    //             "freeBookPromotionSites",
    //             "bookPromotionEmailLists",
    //             "arcReadersForBooks",
    //             "howToBuildArcTeam",
    //             "howToGetBookReviewsBeforeLaunch",
    //             "howToBuildAuthorPlatform",
    //             "emailListForAuthors",
    //             "howToPromoteBookOnSocialMedia",
    //             "howToPromoteBookOnFacebook",
    //             "howToPromoteBookOnTikTok",
    //             "bookMarketingChecklist",
    //             "bookMarketingStrategyForSelfPublishedAuthors"
    //         ]
    //     },
    // },
    // bookLaunchChecklist: {
    //     route: BOOK_LAUNCH_CHECKLIST_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors organize a stronger book launch process:",
    //         bottom: "Continue with related launch, promotion, reviews, and reader growth pages:",
    //         anchor: "Book Launch Checklist",
    //     },
    //     outbound: {
    //         top: [
    //             "bookLaunchStrategyAmazon",
    //             "howToMarketABook",
    //             "howToPromoteABookOnAmazon",
    //             "howToGetBookReviewsBeforeLaunch",
    //             "bookMarketingChecklist"
    //         ],
    //         bottom: [
    //             "bookMarketing",
    //             "bookLaunchStrategyAmazon",
    //             "howToMarketABook",
    //             "howToPromoteABookOnAmazon",
    //             "howToGetFirstBookSales",
    //             "freeBookMarketingStrategies",
    //             "freeBookPromotionSites",
    //             "bookPromotionEmailLists",
    //             "arcReadersForBooks",
    //             "howToBuildArcTeam",
    //             "howToGetBookReviewsBeforeLaunch",
    //             "howToBuildAuthorPlatform",
    //             "emailListForAuthors",
    //             "howToPromoteBookOnSocialMedia",
    //             "howToPromoteBookOnFacebook",
    //             "howToPromoteBookOnTikTok",
    //             "bookMarketingChecklist",
    //             "bookMarketingStrategyForSelfPublishedAuthors"
    //         ]
    //     },
    // },
    // howToGetFirstBookSales: {
    //     route: HOW_TO_GET_FIRST_BOOK_SALES_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors get their first book sales and early momentum:",
    //         bottom: "Continue with related launch, promotion, reviews, and audience-building pages:",
    //         anchor: "How to Get First Book Sales",
    //     },
    //     outbound: {
    //         top: [
    //             "bookMarketing",
    //             "howToMarketABook",
    //             "howToPromoteABookOnAmazon",
    //             "bookLaunchStrategyAmazon",
    //             "bookLaunchChecklist"
    //         ],
    //         bottom: [
    //             "bookMarketing",
    //             "howToMarketABook",
    //             "howToPromoteABookOnAmazon",
    //             "bookLaunchStrategyAmazon",
    //             "bookLaunchChecklist",
    //             "freeBookMarketingStrategies",
    //             "freeBookPromotionSites",
    //             "bookPromotionEmailLists",
    //             "bestBookPromotionSites",
    //             "kindleBookPromotionSites",
    //             "arcReadersForBooks",
    //             "howToBuildArcTeam",
    //             "howToGetBookReviewsBeforeLaunch",
    //             "howToBuildAuthorPlatform",
    //             "emailListForAuthors",
    //             "howToPromoteBookOnSocialMedia",
    //             "howToPromoteBookOnFacebook",
    //             "howToPromoteBookOnTikTok",
    //             "bookMarketingChecklist",
    //             "bookMarketingStrategyForSelfPublishedAuthors"
    //         ]
    //     },
    // },
    // freeBookMarketingStrategies: {
    //     route: FREE_BOOK_MARKETING_STRATEGIES_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors market books with free and low-cost strategies:",
    //         bottom: "Continue with related promotion, launch, reviews, and audience-building pages:",
    //         anchor: "Free Book Marketing Strategies",
    //     },
    //     outbound: {
    //         top: [
    //             "bookMarketing",
    //             "howToMarketABook",
    //             "howToPromoteABookOnAmazon",
    //             "howToGetFirstBookSales",
    //             "bookMarketingStrategyForSelfPublishedAuthors"
    //         ],
    //         bottom: [
    //             "bookMarketing",
    //             "howToMarketABook",
    //             "howToPromoteABookOnAmazon",
    //             "bookLaunchStrategyAmazon",
    //             "bookLaunchChecklist",
    //             "howToGetFirstBookSales",
    //             "freeBookPromotionSites",
    //             "bookPromotionEmailLists",
    //             "bestBookPromotionSites",
    //             "kindleBookPromotionSites",
    //             "arcReadersForBooks",
    //             "howToBuildArcTeam",
    //             "howToGetBookReviewsBeforeLaunch",
    //             "howToBuildAuthorPlatform",
    //             "emailListForAuthors",
    //             "howToPromoteBookOnSocialMedia",
    //             "howToPromoteBookOnFacebook",
    //             "howToPromoteBookOnTikTok",
    //             "bookMarketingChecklist",
    //             "bookMarketingStrategyForSelfPublishedAuthors"
    //         ]
    //     },
    // },
    // freeBookPromotionSites: {
    //     route: FREE_BOOK_PROMOTION_SITES_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors use free promotion channels and visibility sources:",
    //         bottom: "Continue with related launch, promotion, reviews, and audience-building pages:",
    //         anchor: "Free Book Promotion Sites",
    //     },
    //     outbound: {
    //         top: [
    //             "freeBookMarketingStrategies",
    //             "bookMarketing",
    //             "howToMarketABook",
    //             "howToGetFirstBookSales",
    //             "bestBookPromotionSites"
    //         ],
    //         bottom: [
    //             "bookMarketing",
    //             "howToMarketABook",
    //             "howToPromoteABookOnAmazon",
    //             "bookLaunchStrategyAmazon",
    //             "bookLaunchChecklist",
    //             "howToGetFirstBookSales",
    //             "freeBookMarketingStrategies",
    //             "bookPromotionEmailLists",
    //             "bestBookPromotionSites",
    //             "kindleBookPromotionSites",
    //             "arcReadersForBooks",
    //             "howToBuildArcTeam",
    //             "howToGetBookReviewsBeforeLaunch",
    //             "howToBuildAuthorPlatform",
    //             "emailListForAuthors",
    //             "howToPromoteBookOnSocialMedia",
    //             "howToPromoteBookOnFacebook",
    //             "howToPromoteBookOnTikTok",
    //             "bookMarketingChecklist",
    //             "bookMarketingStrategyForSelfPublishedAuthors"
    //         ]
    //     },
    // },
    // bookPromotionEmailLists: {
    //     route: BOOK_PROMOTION_EMAIL_LISTS_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors use email as a book promotion channel:",
    //         bottom: "Continue with related launch, promotion, audience-building, and review pages:",
    //         anchor: "Book Promotion Email Lists",
    //     },
    //     outbound: {
    //         top: [
    //             "bookMarketing",
    //             "freeBookMarketingStrategies",
    //             "freeBookPromotionSites",
    //             "emailListForAuthors",
    //             "bookLaunchStrategyAmazon"
    //         ],
    //         bottom: [
    //             "bookMarketing",
    //             "howToMarketABook",
    //             "howToPromoteABookOnAmazon",
    //             "bookLaunchStrategyAmazon",
    //             "bookLaunchChecklist",
    //             "howToGetFirstBookSales",
    //             "freeBookMarketingStrategies",
    //             "freeBookPromotionSites",
    //             "bestBookPromotionSites",
    //             "kindleBookPromotionSites",
    //             "arcReadersForBooks",
    //             "howToBuildArcTeam",
    //             "howToGetBookReviewsBeforeLaunch",
    //             "howToBuildAuthorPlatform",
    //             "emailListForAuthors",
    //             "howToPromoteBookOnSocialMedia",
    //             "howToPromoteBookOnFacebook",
    //             "howToPromoteBookOnTikTok",
    //             "bookMarketingChecklist",
    //             "bookMarketingStrategyForSelfPublishedAuthors"
    //         ]
    //     },
    // },
    // bestBookPromotionSites: {
    //     route: BEST_BOOK_PROMOTION_SITES_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors compare and choose stronger promotion platforms:",
    //         bottom: "Continue with related launch, visibility, review, and audience-building pages:",
    //         anchor: "Best Book Promotion Sites",
    //     },
    //     outbound: {
    //         top: [
    //             "freeBookPromotionSites",
    //             "freeBookMarketingStrategies",
    //             "bookMarketing",
    //             "howToGetFirstBookSales",
    //             "kindleBookPromotionSites"
    //         ],
    //         bottom: [
    //             "bookMarketing",
    //             "howToMarketABook",
    //             "howToPromoteABookOnAmazon",
    //             "bookLaunchStrategyAmazon",
    //             "bookLaunchChecklist",
    //             "howToGetFirstBookSales",
    //             "freeBookMarketingStrategies",
    //             "freeBookPromotionSites",
    //             "bookPromotionEmailLists",
    //             "kindleBookPromotionSites",
    //             "arcReadersForBooks",
    //             "howToBuildArcTeam",
    //             "howToGetBookReviewsBeforeLaunch",
    //             "howToBuildAuthorPlatform",
    //             "emailListForAuthors",
    //             "howToPromoteBookOnSocialMedia",
    //             "howToPromoteBookOnFacebook",
    //             "howToPromoteBookOnTikTok",
    //             "bookMarketingChecklist",
    //             "bookMarketingStrategyForSelfPublishedAuthors"
    //         ]
    //     },
    // },
    // kindleBookPromotionSites: {
    //     route: KINDLE_BOOK_PROMOTION_SITES_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors use promotion channels built around Kindle visibility:",
    //         bottom: "Continue with related launch, promotion, reviews, and reader growth pages:",
    //         anchor: "Kindle Book Promotion Sites",
    //     },
    //     outbound: {
    //         top: [
    //             "bestBookPromotionSites",
    //             "freeBookPromotionSites",
    //             "bookMarketing",
    //             "howToPromoteABookOnAmazon",
    //             "howToGetFirstBookSales"
    //         ],
    //         bottom: [
    //             "bookMarketing",
    //             "howToMarketABook",
    //             "howToPromoteABookOnAmazon",
    //             "bookLaunchStrategyAmazon",
    //             "bookLaunchChecklist",
    //             "howToGetFirstBookSales",
    //             "freeBookMarketingStrategies",
    //             "freeBookPromotionSites",
    //             "bookPromotionEmailLists",
    //             "bestBookPromotionSites",
    //             "arcReadersForBooks",
    //             "howToBuildArcTeam",
    //             "howToGetBookReviewsBeforeLaunch",
    //             "howToBuildAuthorPlatform",
    //             "emailListForAuthors",
    //             "howToPromoteBookOnSocialMedia",
    //             "howToPromoteBookOnFacebook",
    //             "howToPromoteBookOnTikTok",
    //             "bookMarketingChecklist",
    //             "bookMarketingStrategyForSelfPublishedAuthors"
    //         ]
    //     },
    // },
    // arcReadersForBooks: {
    //     route: ARC_READERS_FOR_BOOKS_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors use ARC readers as part of a stronger launch process:",
    //         bottom: "Continue with related review, launch, promotion, and audience-building pages:",
    //         anchor: "ARC Readers for Books",
    //     },
    //     outbound: {
    //         top: [
    //             "howToGetBookReviewsBeforeLaunch",
    //             "howToBuildArcTeam",
    //             "bookLaunchStrategyAmazon",
    //             "bookLaunchChecklist",
    //             "howToGetFirstBookSales"
    //         ],
    //         bottom: [
    //             "bookMarketing",
    //             "howToMarketABook",
    //             "bookLaunchStrategyAmazon",
    //             "bookLaunchChecklist",
    //             "howToGetFirstBookSales",
    //             "freeBookMarketingStrategies",
    //             "freeBookPromotionSites",
    //             "bookPromotionEmailLists",
    //             "bestBookPromotionSites",
    //             "kindleBookPromotionSites",
    //             "howToBuildArcTeam",
    //             "howToGetBookReviewsBeforeLaunch",
    //             "howToBuildAuthorPlatform",
    //             "emailListForAuthors",
    //             "howToPromoteBookOnSocialMedia",
    //             "howToPromoteBookOnFacebook",
    //             "howToPromoteBookOnTikTok",
    //             "bookMarketingChecklist",
    //             "bookMarketingStrategyForSelfPublishedAuthors",
    //             "getAmazonBookReviews"
    //         ]
    //     },
    // },
    // howToBuildArcTeam: {
    //     route: HOW_TO_BUILD_ARC_TEAM_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors build and organize stronger ARC teams:",
    //         bottom: "Continue with related ARC, launch, review, and audience-building pages:",
    //         anchor: "How to Build an ARC Team",
    //     },
    //     outbound: {
    //         top: [
    //             "arcReadersForBooks",
    //             "howToGetBookReviewsBeforeLaunch",
    //             "bookLaunchStrategyAmazon",
    //             "bookLaunchChecklist",
    //             "howToGetFirstBookSales"
    //         ],
    //         bottom: [
    //             "bookMarketing",
    //             "howToMarketABook",
    //             "bookLaunchStrategyAmazon",
    //             "bookLaunchChecklist",
    //             "howToGetFirstBookSales",
    //             "freeBookMarketingStrategies",
    //             "freeBookPromotionSites",
    //             "bookPromotionEmailLists",
    //             "bestBookPromotionSites",
    //             "kindleBookPromotionSites",
    //             "arcReadersForBooks",
    //             "howToGetBookReviewsBeforeLaunch",
    //             "howToBuildAuthorPlatform",
    //             "emailListForAuthors",
    //             "howToPromoteBookOnSocialMedia",
    //             "howToPromoteBookOnFacebook",
    //             "howToPromoteBookOnTikTok",
    //             "bookMarketingChecklist",
    //             "bookMarketingStrategyForSelfPublishedAuthors",
    //             "getAmazonBookReviews"
    //         ]
    //     },
    // },
    // howToGetBookReviewsBeforeLaunch: {
    //     route: HOW_TO_GET_BOOK_REVIEWS_BEFORE_LAUNCH_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors prepare early reviews before launch:",
    //         bottom: "Continue with related ARC, launch, promotion, and reader-growth pages:",
    //         anchor: "How to Get Book Reviews Before Launch",
    //     },
    //     outbound: {
    //         top: [
    //             "arcReadersForBooks",
    //             "howToBuildArcTeam",
    //             "bookLaunchStrategyAmazon",
    //             "bookLaunchChecklist",
    //             "howToGetFirstBookSales"
    //         ],
    //         bottom: [
    //             "bookMarketing",
    //             "howToMarketABook",
    //             "bookLaunchStrategyAmazon",
    //             "bookLaunchChecklist",
    //             "howToGetFirstBookSales",
    //             "freeBookMarketingStrategies",
    //             "freeBookPromotionSites",
    //             "bookPromotionEmailLists",
    //             "bestBookPromotionSites",
    //             "kindleBookPromotionSites",
    //             "arcReadersForBooks",
    //             "howToBuildArcTeam",
    //             "howToBuildAuthorPlatform",
    //             "emailListForAuthors",
    //             "howToPromoteBookOnSocialMedia",
    //             "howToPromoteBookOnFacebook",
    //             "howToPromoteBookOnTikTok",
    //             "bookMarketingChecklist",
    //             "bookMarketingStrategyForSelfPublishedAuthors",
    //             "getAmazonBookReviews"
    //         ]
    //     },
    // },
    // howToBuildAuthorPlatform: {
    //     route: HOW_TO_BUILD_AUTHOR_PLATFORM_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors build audience foundations and long-term visibility:",
    //         bottom: "Continue with related email, launch, promotion, and reader-growth pages:",
    //         anchor: "How to Build an Author Platform",
    //     },
    //     outbound: {
    //         top: [
    //             "emailListForAuthors",
    //             "bookMarketing",
    //             "freeBookMarketingStrategies",
    //             "bookPromotionEmailLists",
    //             "howToPromoteBookOnSocialMedia"
    //         ],
    //         bottom: [
    //             "bookMarketing",
    //             "howToMarketABook",
    //             "howToPromoteABookOnAmazon",
    //             "bookLaunchStrategyAmazon",
    //             "bookLaunchChecklist",
    //             "howToGetFirstBookSales",
    //             "freeBookMarketingStrategies",
    //             "freeBookPromotionSites",
    //             "bookPromotionEmailLists",
    //             "bestBookPromotionSites",
    //             "kindleBookPromotionSites",
    //             "arcReadersForBooks",
    //             "howToBuildArcTeam",
    //             "howToGetBookReviewsBeforeLaunch",
    //             "emailListForAuthors",
    //             "howToPromoteBookOnSocialMedia",
    //             "howToPromoteBookOnFacebook",
    //             "howToPromoteBookOnTikTok",
    //             "bookMarketingChecklist",
    //             "bookMarketingStrategyForSelfPublishedAuthors"
    //         ]
    //     },
    // },
    // emailListForAuthors: {
    //     route: EMAIL_LIST_FOR_AUTHORS_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors build reader relationships through email:",
    //         bottom: "Continue with related platform, launch, promotion, and audience-growth pages:",
    //         anchor: "Email List for Authors",
    //     },
    //     outbound: {
    //         top: [
    //             "howToBuildAuthorPlatform",
    //             "bookPromotionEmailLists",
    //             "bookMarketing",
    //             "freeBookMarketingStrategies",
    //             "howToPromoteBookOnSocialMedia"
    //         ],
    //         bottom: [
    //             "bookMarketing",
    //             "howToMarketABook",
    //             "howToPromoteABookOnAmazon",
    //             "bookLaunchStrategyAmazon",
    //             "bookLaunchChecklist",
    //             "howToGetFirstBookSales",
    //             "freeBookMarketingStrategies",
    //             "freeBookPromotionSites",
    //             "bookPromotionEmailLists",
    //             "bestBookPromotionSites",
    //             "kindleBookPromotionSites",
    //             "arcReadersForBooks",
    //             "howToBuildArcTeam",
    //             "howToGetBookReviewsBeforeLaunch",
    //             "howToBuildAuthorPlatform",
    //             "howToPromoteBookOnSocialMedia",
    //             "howToPromoteBookOnFacebook",
    //             "howToPromoteBookOnTikTok",
    //             "bookMarketingChecklist",
    //             "bookMarketingStrategyForSelfPublishedAuthors"
    //         ]
    //     },
    // },
    // howToPromoteBookOnSocialMedia: {
    //     route: HOW_TO_PROMOTE_BOOK_ON_SOCIAL_MEDIA_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors use social platforms for book visibility and audience growth:",
    //         bottom: "Continue with related email, launch, promotion, and long-term marketing pages:",
    //         anchor: "How to Promote a Book on Social Media",
    //     },
    //     outbound: {
    //         top: [
    //             "howToBuildAuthorPlatform",
    //             "emailListForAuthors",
    //             "bookMarketing",
    //             "freeBookMarketingStrategies",
    //             "howToPromoteBookOnFacebook"
    //         ],
    //         bottom: [
    //             "bookMarketing",
    //             "howToMarketABook",
    //             "howToPromoteABookOnAmazon",
    //             "bookLaunchStrategyAmazon",
    //             "bookLaunchChecklist",
    //             "howToGetFirstBookSales",
    //             "freeBookMarketingStrategies",
    //             "freeBookPromotionSites",
    //             "bookPromotionEmailLists",
    //             "bestBookPromotionSites",
    //             "kindleBookPromotionSites",
    //             "arcReadersForBooks",
    //             "howToBuildArcTeam",
    //             "howToGetBookReviewsBeforeLaunch",
    //             "howToBuildAuthorPlatform",
    //             "emailListForAuthors",
    //             "howToPromoteBookOnFacebook",
    //             "howToPromoteBookOnTikTok",
    //             "bookMarketingChecklist",
    //             "bookMarketingStrategyForSelfPublishedAuthors"
    //         ]
    //     },
    // },
    // howToPromoteBookOnFacebook: {
    //     route: HOW_TO_PROMOTE_BOOK_ON_FACEBOOK_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors use Facebook for book visibility and reader engagement:",
    //         bottom: "Continue with related social media, launch, email, and marketing pages:",
    //         anchor: "How to Promote a Book on Facebook",
    //     },
    //     outbound: {
    //         top: [
    //             "howToPromoteBookOnSocialMedia",
    //             "howToBuildAuthorPlatform",
    //             "emailListForAuthors",
    //             "bookMarketing",
    //             "howToPromoteBookOnTikTok"
    //         ],
    //         bottom: [
    //             "bookMarketing",
    //             "howToMarketABook",
    //             "howToPromoteABookOnAmazon",
    //             "bookLaunchStrategyAmazon",
    //             "bookLaunchChecklist",
    //             "howToGetFirstBookSales",
    //             "freeBookMarketingStrategies",
    //             "freeBookPromotionSites",
    //             "bookPromotionEmailLists",
    //             "bestBookPromotionSites",
    //             "kindleBookPromotionSites",
    //             "arcReadersForBooks",
    //             "howToBuildArcTeam",
    //             "howToGetBookReviewsBeforeLaunch",
    //             "howToBuildAuthorPlatform",
    //             "emailListForAuthors",
    //             "howToPromoteBookOnSocialMedia",
    //             "howToPromoteBookOnTikTok",
    //             "bookMarketingChecklist",
    //             "bookMarketingStrategyForSelfPublishedAuthors"
    //         ]
    //     },
    // },
    // howToPromoteBookOnTiktok: {
    //     route: HOW_TO_PROMOTE_BOOK_ON_TIKTOK_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors use TikTok for book visibility and reader attention:",
    //         bottom: "Continue with related social media, launch, email, and long-term marketing pages:",
    //         anchor: "How to Promote a Book on TikTok",
    //     },
    //     outbound: {
    //         top: [
    //             "howToPromoteBookOnSocialMedia",
    //             "howToPromoteBookOnFacebook",
    //             "howToBuildAuthorPlatform",
    //             "emailListForAuthors",
    //             "bookMarketing"
    //         ],
    //         bottom: [
    //             "bookMarketing",
    //             "howToMarketABook",
    //             "howToPromoteABookOnAmazon",
    //             "bookLaunchStrategyAmazon",
    //             "bookLaunchChecklist",
    //             "howToGetFirstBookSales",
    //             "freeBookMarketingStrategies",
    //             "freeBookPromotionSites",
    //             "bookPromotionEmailLists",
    //             "bestBookPromotionSites",
    //             "kindleBookPromotionSites",
    //             "arcReadersForBooks",
    //             "howToBuildArcTeam",
    //             "howToGetBookReviewsBeforeLaunch",
    //             "howToBuildAuthorPlatform",
    //             "emailListForAuthors",
    //             "howToPromoteBookOnSocialMedia",
    //             "howToPromoteBookOnFacebook",
    //             "bookMarketingChecklist",
    //             "bookMarketingStrategyForSelfPublishedAuthors"
    //         ]
    //     },
    // },
    // bookMarketingChecklist: {
    //     route: BOOK_MARKETING_CHECKLIST_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors organize book marketing into a clearer system:",
    //         bottom: "Continue with related launch, promotion, email, and audience-growth pages:",
    //         anchor: "Book Marketing Checklist",
    //     },
    //     outbound: {
    //         top: [
    //             "bookMarketing",
    //             "howToMarketABook",
    //             "bookLaunchChecklist",
    //             "freeBookMarketingStrategies",
    //             "bookMarketingStrategyForSelfPublishedAuthors"
    //         ],
    //         bottom: [
    //             "bookMarketing",
    //             "howToMarketABook",
    //             "howToPromoteABookOnAmazon",
    //             "bookLaunchStrategyAmazon",
    //             "bookLaunchChecklist",
    //             "howToGetFirstBookSales",
    //             "freeBookMarketingStrategies",
    //             "freeBookPromotionSites",
    //             "bookPromotionEmailLists",
    //             "bestBookPromotionSites",
    //             "kindleBookPromotionSites",
    //             "arcReadersForBooks",
    //             "howToBuildArcTeam",
    //             "howToGetBookReviewsBeforeLaunch",
    //             "howToBuildAuthorPlatform",
    //             "emailListForAuthors",
    //             "howToPromoteBookOnSocialMedia",
    //             "howToPromoteBookOnFacebook",
    //             "howToPromoteBookOnTiktok",
    //             "bookMarketingStrategyForSelfPublishedAuthors"
    //         ]
    //     },
    // },
    // bookMarketingStrategyForSelfPublishedAuthors: {
    //     route: BOOK_MARKETING_STRATEGY_FOR_SELF_PUBLISHED_AUTHORS_ROUTE,
    //     labels: {
    //         top: "Explore pages that help self-published authors build a stronger marketing strategy:",
    //         bottom: "Continue with related launch, reviews, discoverability, and audience-growth pages:",
    //         anchor: "Book Marketing Strategy for Self Published Authors",
    //     },
    //     outbound: {
    //         top: [
    //             "bookMarketing",
    //             "howToMarketABook",
    //             "bookMarketingChecklist",
    //             "freeBookMarketingStrategies",
    //             "howToBuildAuthorPlatform"
    //         ],
    //         bottom: [
    //             "howToMarketABook",
    //             "howToPromoteABookOnAmazon",
    //             "bookLaunchStrategyAmazon",
    //             "bookLaunchChecklist",
    //             "howToGetFirstBookSales",
    //             "freeBookMarketingStrategies",
    //             "freeBookPromotionSites",
    //             "bookPromotionEmailLists",
    //             "bestBookPromotionSites",
    //             "kindleBookPromotionSites",
    //             "arcReadersForBooks",
    //             "howToBuildArcTeam",
    //             "howToGetBookReviewsBeforeLaunch",
    //             "howToBuildAuthorPlatform",
    //             "emailListForAuthors",
    //             "howToPromoteBookOnSocialMedia",
    //             "howToPromoteBookOnFacebook",
    //             "howToPromoteBookOnTiktok",
    //             "bookMarketingChecklist",
    //             "bookMarketing"
    //         ]
    //     },
    // },

    amazonAdsForBooks: {
        route: AMAZON_ADS_FOR_BOOKS_ROUTE,
        pageKey: "amazonAdsForBooks",
        textMode: "amazonAdsForBooks",
        labels: {
            top: "Explore pages that help improve Amazon book advertising strategy:",
            bottom: "Continue with related KDP marketing tools and guides:",
            anchor: "Amazon Ads for Books",
        },
        outbound: {
            top: ["kdpEarnings", "kdpNicheResearch", "amazonAdsForBooks", "kdpToolsHub",
                "howAmazonAdsForBooksWork",
                "amazonAdsForKdpBeginners",
                "amazonAdsTypesExplained",
                "amazonAdsKeywordStrategy"
            ],
            bottom: ["kdpEarnings", "kdpNicheResearch", "amazonAdsForBooks", "kdpToolsHub",
                "howAmazonAdsForBooksWork",
                "amazonAdsForKdpBeginners",
                "amazonAdsTypesExplained",

                "amazonAdsLaunchStrategy",
                "amazonAdsForBookLaunch",
                "amazonAdsKeywordStrategy",

                "amazonAdsOptimizationStrategy",
                "howToLowerAcosAmazonAds",
                "howToImproveAmazonAdsConversion",
                "howToScaleAmazonAdsForBooks",

                "amazonAdsBudgetStrategy",
                "amazonAdsBiddingStrategy",

                "amazonAdsAcosExplained",
                "amazonAdsCtrExplained",
                "amazonAdsRoasExplained",

                "whyAmazonAdsNotWorking",
                "amazonAdsNoImpressions",
                "amazonAdsNoClicks",
                "amazonAdsHighAcosProblem"
            ]
        },
    },
    // howAmazonAdsForBooksWork: {
    //     route: HOW_AMAZON_ADS_FOR_BOOKS_WORK_ROUTE,
    //     labels: {
    //         top: "Explore pages that explain how Amazon Ads work for authors and book campaigns:",
    //         bottom: "Continue with related pages about ad strategy, keywords, bidding, and optimization:",
    //         anchor: "How Amazon Ads for Books Work",
    //     },
    //     outbound: {
    //         top: [
    //             "amazonAdsForBooks",
    //             "amazonAdsForKdpBeginners",
    //             "amazonAdsTypesExplained",
    //             "amazonAdsKeywordStrategy",
    //             "amazonAdsLaunchStrategy"
    //         ],
    //         bottom: [
    //             "amazonAdsForBooks",
    //             "amazonAdsForKdpBeginners",
    //             "amazonAdsTypesExplained",
    //             "amazonAdsLaunchStrategy",
    //             "amazonAdsKeywordStrategy",
    //             "amazonAdsForBookLaunch",
    //             "amazonAdsOptimizationStrategy",
    //             "howToLowerAcosAmazonAds",
    //             "howToImproveAmazonAdsConversion",
    //             "howToScaleAmazonAdsForBooks",
    //             "amazonAdsBudgetStrategy",
    //             "amazonAdsBiddingStrategy",
    //             "amazonAdsAcosExplained",
    //             "amazonAdsCtrExplained",
    //             "amazonAdsRoasExplained",
    //             "whyAmazonAdsNotWorking",
    //             "amazonAdsNoImpressions",
    //             "amazonAdsNoClicks",
    //             "amazonAdsHighAcosProblem"
    //         ]
    //     },
    // },
    // amazonAdsForKdpBeginners: {
    //     route: AMAZON_ADS_FOR_KDP_BEGINNERS_ROUTE,
    //     labels: {
    //         top: "Explore pages that help beginners understand Amazon Ads for books more clearly:",
    //         bottom: "Continue with related pages about ad types, keywords, bidding, and optimization:",
    //         anchor: "Amazon Ads for KDP Beginners",
    //     },
    //     outbound: {
    //         top: [
    //             "amazonAdsForBooks",
    //             "howAmazonAdsForBooksWork",
    //             "amazonAdsTypesExplained",
    //             "amazonAdsKeywordStrategy",
    //             "amazonAdsBudgetStrategy"
    //         ],
    //         bottom: [
    //             "amazonAdsForBooks",
    //             "howAmazonAdsForBooksWork",
    //             "amazonAdsTypesExplained",
    //             "amazonAdsLaunchStrategy",
    //             "amazonAdsKeywordStrategy",
    //             "amazonAdsForBookLaunch",
    //             "amazonAdsOptimizationStrategy",
    //             "howToLowerAcosAmazonAds",
    //             "howToImproveAmazonAdsConversion",
    //             "howToScaleAmazonAdsForBooks",
    //             "amazonAdsBudgetStrategy",
    //             "amazonAdsBiddingStrategy",
    //             "amazonAdsAcosExplained",
    //             "amazonAdsCtrExplained",
    //             "amazonAdsRoasExplained",
    //             "whyAmazonAdsNotWorking",
    //             "amazonAdsNoImpressions",
    //             "amazonAdsNoClicks",
    //             "amazonAdsHighAcosProblem"
    //         ]
    //     },
    // },
    // amazonAdsTypesExplained: {
    //     route: AMAZON_ADS_TYPES_EXPLAINED_ROUTE,
    //     labels: {
    //         top: "Explore pages that explain the main Amazon ad types used for book campaigns:",
    //         bottom: "Continue with related pages about targeting, launches, bidding, and optimization:",
    //         anchor: "Amazon Ads Types Explained",
    //     },
    //     outbound: {
    //         top: [
    //             "amazonAdsForBooks",
    //             "howAmazonAdsForBooksWork",
    //             "amazonAdsForKdpBeginners",
    //             "amazonAdsKeywordStrategy",
    //             "amazonAdsBiddingStrategy"
    //         ],
    //         bottom: [
    //             "amazonAdsForBooks",
    //             "howAmazonAdsForBooksWork",
    //             "amazonAdsForKdpBeginners",
    //             "amazonAdsLaunchStrategy",
    //             "amazonAdsKeywordStrategy",
    //             "amazonAdsForBookLaunch",
    //             "amazonAdsOptimizationStrategy",
    //             "howToLowerAcosAmazonAds",
    //             "howToImproveAmazonAdsConversion",
    //             "howToScaleAmazonAdsForBooks",
    //             "amazonAdsBudgetStrategy",
    //             "amazonAdsBiddingStrategy",
    //             "amazonAdsAcosExplained",
    //             "amazonAdsCtrExplained",
    //             "amazonAdsRoasExplained",
    //             "whyAmazonAdsNotWorking",
    //             "amazonAdsNoImpressions",
    //             "amazonAdsNoClicks",
    //             "amazonAdsHighAcosProblem"
    //         ]
    //     },
    // },
    // amazonAdsLaunchStrategy: {
    //     route: AMAZON_ADS_LAUNCH_STRATEGY_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors use Amazon Ads more effectively during book launch:",
    //         bottom: "Continue with related pages about launch campaigns, keywords, bidding, and optimization:",
    //         anchor: "Amazon Ads Launch Strategy",
    //     },
    //     outbound: {
    //         top: [
    //             "amazonAdsForBooks",
    //             "howAmazonAdsForBooksWork",
    //             "amazonAdsForKdpBeginners",
    //             "amazonAdsForBookLaunch",
    //             "amazonAdsKeywordStrategy"
    //         ],
    //         bottom: [
    //             "amazonAdsForBooks",
    //             "howAmazonAdsForBooksWork",
    //             "amazonAdsForKdpBeginners",
    //             "amazonAdsTypesExplained",
    //             "amazonAdsKeywordStrategy",
    //             "amazonAdsForBookLaunch",
    //             "amazonAdsOptimizationStrategy",
    //             "howToLowerAcosAmazonAds",
    //             "howToImproveAmazonAdsConversion",
    //             "howToScaleAmazonAdsForBooks",
    //             "amazonAdsBudgetStrategy",
    //             "amazonAdsBiddingStrategy",
    //             "amazonAdsAcosExplained",
    //             "amazonAdsCtrExplained",
    //             "amazonAdsRoasExplained",
    //             "whyAmazonAdsNotWorking",
    //             "amazonAdsNoImpressions",
    //             "amazonAdsNoClicks",
    //             "amazonAdsHighAcosProblem"
    //         ]
    //     },
    // },
    // amazonAdsKeywordStrategy: {
    //     route: AMAZON_ADS_KEYWORD_STRATEGY_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors build stronger keyword strategy for Amazon Ads:",
    //         bottom: "Continue with related pages about launch campaigns, bidding, targeting, and optimization:",
    //         anchor: "Amazon Ads Keyword Strategy",
    //     },
    //     outbound: {
    //         top: [
    //             "amazonAdsForBooks",
    //             "howAmazonAdsForBooksWork",
    //             "amazonAdsForKdpBeginners",
    //             "amazonAdsTypesExplained",
    //             "amazonAdsBiddingStrategy"
    //         ],
    //         bottom: [
    //             "amazonAdsForBooks",
    //             "howAmazonAdsForBooksWork",
    //             "amazonAdsForKdpBeginners",
    //             "amazonAdsTypesExplained",
    //             "amazonAdsLaunchStrategy",
    //             "amazonAdsForBookLaunch",
    //             "amazonAdsOptimizationStrategy",
    //             "howToLowerAcosAmazonAds",
    //             "howToImproveAmazonAdsConversion",
    //             "howToScaleAmazonAdsForBooks",
    //             "amazonAdsBudgetStrategy",
    //             "amazonAdsBiddingStrategy",
    //             "amazonAdsAcosExplained",
    //             "amazonAdsCtrExplained",
    //             "amazonAdsRoasExplained",
    //             "whyAmazonAdsNotWorking",
    //             "amazonAdsNoImpressions",
    //             "amazonAdsNoClicks",
    //             "amazonAdsHighAcosProblem"
    //         ]
    //     },
    // },
    // amazonAdsForBookLaunch: {
    //     route: AMAZON_ADS_FOR_BOOK_LAUNCH_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors use Amazon Ads specifically for new book launch campaigns:",
    //         bottom: "Continue with related pages about launch strategy, keywords, bidding, and ad optimization:",
    //         anchor: "Amazon Ads for Book Launch",
    //     },
    //     outbound: {
    //         top: [
    //             "amazonAdsForBooks",
    //             "amazonAdsLaunchStrategy",
    //             "howAmazonAdsForBooksWork",
    //             "amazonAdsKeywordStrategy",
    //             "amazonAdsForKdpBeginners"
    //         ],
    //         bottom: [
    //             "amazonAdsForBooks",
    //             "howAmazonAdsForBooksWork",
    //             "amazonAdsForKdpBeginners",
    //             "amazonAdsTypesExplained",
    //             "amazonAdsLaunchStrategy",
    //             "amazonAdsKeywordStrategy",
    //             "amazonAdsOptimizationStrategy",
    //             "howToLowerAcosAmazonAds",
    //             "howToImproveAmazonAdsConversion",
    //             "howToScaleAmazonAdsForBooks",
    //             "amazonAdsBudgetStrategy",
    //             "amazonAdsBiddingStrategy",
    //             "amazonAdsAcosExplained",
    //             "amazonAdsCtrExplained",
    //             "amazonAdsRoasExplained",
    //             "whyAmazonAdsNotWorking",
    //             "amazonAdsNoImpressions",
    //             "amazonAdsNoClicks",
    //             "amazonAdsHighAcosProblem"
    //         ]
    //     },
    // },
    // amazonAdsOptimizationStrategy: {
    //     route: AMAZON_ADS_OPTIMIZATION_STRATEGY_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors optimize Amazon Ads campaigns more effectively:",
    //         bottom: "Continue with related pages about ACOS, conversion, scaling, bidding, and ad problems:",
    //         anchor: "Amazon Ads Optimization Strategy",
    //     },
    //     outbound: {
    //         top: [
    //             "amazonAdsForBooks",
    //             "amazonAdsKeywordStrategy",
    //             "amazonAdsBiddingStrategy",
    //             "howToImproveAmazonAdsConversion",
    //             "howToLowerAcosAmazonAds"
    //         ],
    //         bottom: [
    //             "amazonAdsForBooks",
    //             "howAmazonAdsForBooksWork",
    //             "amazonAdsForKdpBeginners",
    //             "amazonAdsTypesExplained",
    //             "amazonAdsLaunchStrategy",
    //             "amazonAdsKeywordStrategy",
    //             "amazonAdsForBookLaunch",
    //             "howToLowerAcosAmazonAds",
    //             "howToImproveAmazonAdsConversion",
    //             "howToScaleAmazonAdsForBooks",
    //             "amazonAdsBudgetStrategy",
    //             "amazonAdsBiddingStrategy",
    //             "amazonAdsAcosExplained",
    //             "amazonAdsCtrExplained",
    //             "amazonAdsRoasExplained",
    //             "whyAmazonAdsNotWorking",
    //             "amazonAdsNoImpressions",
    //             "amazonAdsNoClicks",
    //             "amazonAdsHighAcosProblem"
    //         ]
    //     },
    // },
    // howToLowerAcosAmazonAds: {
    //     route: HOW_TO_LOWER_ACOS_AMAZON_ADS_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors reduce ACOS and improve Amazon Ads efficiency:",
    //         bottom: "Continue with related pages about optimization, conversion, bidding, and ad performance problems:",
    //         anchor: "How to Lower ACOS Amazon Ads",
    //     },
    //     outbound: {
    //         top: [
    //             "amazonAdsOptimizationStrategy",
    //             "amazonAdsAcosExplained",
    //             "howToImproveAmazonAdsConversion",
    //             "amazonAdsBiddingStrategy",
    //             "amazonAdsKeywordStrategy"
    //         ],
    //         bottom: [
    //             "amazonAdsForBooks",
    //             "howAmazonAdsForBooksWork",
    //             "amazonAdsForKdpBeginners",
    //             "amazonAdsTypesExplained",
    //             "amazonAdsLaunchStrategy",
    //             "amazonAdsKeywordStrategy",
    //             "amazonAdsForBookLaunch",
    //             "amazonAdsOptimizationStrategy",
    //             "howToImproveAmazonAdsConversion",
    //             "howToScaleAmazonAdsForBooks",
    //             "amazonAdsBudgetStrategy",
    //             "amazonAdsBiddingStrategy",
    //             "amazonAdsAcosExplained",
    //             "amazonAdsCtrExplained",
    //             "amazonAdsRoasExplained",
    //             "whyAmazonAdsNotWorking",
    //             "amazonAdsNoImpressions",
    //             "amazonAdsNoClicks",
    //             "amazonAdsHighAcosProblem"
    //         ]
    //     },
    // },
    // howToImproveAmazonAdsConversion: {
    //     route: HOW_TO_IMPROVE_AMAZON_ADS_CONVERSION_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors improve Amazon Ads conversion and turn clicks into sales:",
    //         bottom: "Continue with related pages about ACOS, optimization, bidding, scaling, and ad performance problems:",
    //         anchor: "How to Improve Amazon Ads Conversion",
    //     },
    //     outbound: {
    //         top: [
    //             "amazonAdsOptimizationStrategy",
    //             "howToLowerAcosAmazonAds",
    //             "amazonAdsKeywordStrategy",
    //             "amazonAdsBiddingStrategy",
    //             "amazonAdsRoasExplained"
    //         ],
    //         bottom: [
    //             "amazonAdsForBooks",
    //             "howAmazonAdsForBooksWork",
    //             "amazonAdsForKdpBeginners",
    //             "amazonAdsTypesExplained",
    //             "amazonAdsLaunchStrategy",
    //             "amazonAdsKeywordStrategy",
    //             "amazonAdsForBookLaunch",
    //             "amazonAdsOptimizationStrategy",
    //             "howToLowerAcosAmazonAds",
    //             "howToScaleAmazonAdsForBooks",
    //             "amazonAdsBudgetStrategy",
    //             "amazonAdsBiddingStrategy",
    //             "amazonAdsAcosExplained",
    //             "amazonAdsCtrExplained",
    //             "amazonAdsRoasExplained",
    //             "whyAmazonAdsNotWorking",
    //             "amazonAdsNoImpressions",
    //             "amazonAdsNoClicks",
    //             "amazonAdsHighAcosProblem"
    //         ]
    //     },
    // },
    // howToScaleAmazonAdsForBooks: {
    //     route: HOW_TO_SCALE_AMAZON_ADS_FOR_BOOKS_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors scale Amazon Ads for books more strategically:",
    //         bottom: "Continue with related pages about optimization, ACOS, conversion, bidding, and ad performance problems:",
    //         anchor: "How to Scale Amazon Ads for Books",
    //     },
    //     outbound: {
    //         top: [
    //             "amazonAdsOptimizationStrategy",
    //             "howToImproveAmazonAdsConversion",
    //             "howToLowerAcosAmazonAds",
    //             "amazonAdsBudgetStrategy",
    //             "amazonAdsBiddingStrategy"
    //         ],
    //         bottom: [
    //             "amazonAdsForBooks",
    //             "howAmazonAdsForBooksWork",
    //             "amazonAdsForKdpBeginners",
    //             "amazonAdsTypesExplained",
    //             "amazonAdsLaunchStrategy",
    //             "amazonAdsKeywordStrategy",
    //             "amazonAdsForBookLaunch",
    //             "amazonAdsOptimizationStrategy",
    //             "howToLowerAcosAmazonAds",
    //             "howToImproveAmazonAdsConversion",
    //             "amazonAdsBudgetStrategy",
    //             "amazonAdsBiddingStrategy",
    //             "amazonAdsAcosExplained",
    //             "amazonAdsCtrExplained",
    //             "amazonAdsRoasExplained",
    //             "whyAmazonAdsNotWorking",
    //             "amazonAdsNoImpressions",
    //             "amazonAdsNoClicks",
    //             "amazonAdsHighAcosProblem"
    //         ]
    //     },
    // },
    // amazonAdsBudgetStrategy: {
    //     route: AMAZON_ADS_BUDGET_STRATEGY_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors plan and allocate Amazon Ads budgets more strategically:",
    //         bottom: "Continue with related pages about bidding, optimization, scaling, and ad performance problems:",
    //         anchor: "Amazon Ads Budget Strategy",
    //     },
    //     outbound: {
    //         top: [
    //             "amazonAdsForBooks",
    //             "amazonAdsForKdpBeginners",
    //             "amazonAdsLaunchStrategy",
    //             "amazonAdsOptimizationStrategy",
    //             "amazonAdsBiddingStrategy"
    //         ],
    //         bottom: [
    //             "amazonAdsForBooks",
    //             "howAmazonAdsForBooksWork",
    //             "amazonAdsForKdpBeginners",
    //             "amazonAdsTypesExplained",
    //             "amazonAdsLaunchStrategy",
    //             "amazonAdsKeywordStrategy",
    //             "amazonAdsForBookLaunch",
    //             "amazonAdsOptimizationStrategy",
    //             "howToLowerAcosAmazonAds",
    //             "howToImproveAmazonAdsConversion",
    //             "howToScaleAmazonAdsForBooks",
    //             "amazonAdsBiddingStrategy",
    //             "amazonAdsAcosExplained",
    //             "amazonAdsCtrExplained",
    //             "amazonAdsRoasExplained",
    //             "whyAmazonAdsNotWorking",
    //             "amazonAdsNoImpressions",
    //             "amazonAdsNoClicks",
    //             "amazonAdsHighAcosProblem"
    //         ]
    //     },
    // },
    // amazonAdsBiddingStrategy: {
    //     route: AMAZON_ADS_BIDDING_STRATEGY_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors manage Amazon Ads bids more strategically:",
    //         bottom: "Continue with related pages about budgets, keywords, optimization, and ad performance problems:",
    //         anchor: "Amazon Ads Bidding Strategy",
    //     },
    //     outbound: {
    //         top: [
    //             "amazonAdsBudgetStrategy",
    //             "amazonAdsKeywordStrategy",
    //             "amazonAdsOptimizationStrategy",
    //             "howToLowerAcosAmazonAds",
    //             "howToScaleAmazonAdsForBooks"
    //         ],
    //         bottom: [
    //             "amazonAdsForBooks",
    //             "howAmazonAdsForBooksWork",
    //             "amazonAdsForKdpBeginners",
    //             "amazonAdsTypesExplained",
    //             "amazonAdsLaunchStrategy",
    //             "amazonAdsKeywordStrategy",
    //             "amazonAdsForBookLaunch",
    //             "amazonAdsOptimizationStrategy",
    //             "howToLowerAcosAmazonAds",
    //             "howToImproveAmazonAdsConversion",
    //             "howToScaleAmazonAdsForBooks",
    //             "amazonAdsBudgetStrategy",
    //             "amazonAdsAcosExplained",
    //             "amazonAdsCtrExplained",
    //             "amazonAdsRoasExplained",
    //             "whyAmazonAdsNotWorking",
    //             "amazonAdsNoImpressions",
    //             "amazonAdsNoClicks",
    //             "amazonAdsHighAcosProblem"
    //         ]
    //     },
    // },
    // amazonAdsAcosExplained: {
    //     route: AMAZON_ADS_ACOS_EXPLAINED_ROUTE,
    //     labels: {
    //         top: "Explore pages that explain what ACOS means and how authors use it in Amazon Ads:",
    //         bottom: "Continue with related pages about optimization, conversion, bidding, and ad performance problems:",
    //         anchor: "Amazon Ads ACOS Explained",
    //     },
    //     outbound: {
    //         top: [
    //             "howToLowerAcosAmazonAds",
    //             "amazonAdsOptimizationStrategy",
    //             "howToImproveAmazonAdsConversion",
    //             "amazonAdsRoasExplained",
    //             "amazonAdsBiddingStrategy"
    //         ],
    //         bottom: [
    //             "amazonAdsForBooks",
    //             "howAmazonAdsForBooksWork",
    //             "amazonAdsForKdpBeginners",
    //             "amazonAdsTypesExplained",
    //             "amazonAdsLaunchStrategy",
    //             "amazonAdsKeywordStrategy",
    //             "amazonAdsForBookLaunch",
    //             "amazonAdsOptimizationStrategy",
    //             "howToLowerAcosAmazonAds",
    //             "howToImproveAmazonAdsConversion",
    //             "howToScaleAmazonAdsForBooks",
    //             "amazonAdsBudgetStrategy",
    //             "amazonAdsBiddingStrategy",
    //             "amazonAdsCtrExplained",
    //             "amazonAdsRoasExplained",
    //             "whyAmazonAdsNotWorking",
    //             "amazonAdsNoImpressions",
    //             "amazonAdsNoClicks",
    //             "amazonAdsHighAcosProblem"
    //         ]
    //     },
    // },
    // amazonAdsCtrExplained: {
    //     route: AMAZON_ADS_CTR_EXPLAINED_ROUTE,
    //     labels: {
    //         top: "Explore pages that explain what CTR means and how authors use it in Amazon Ads:",
    //         bottom: "Continue with related pages about ACOS, ROAS, conversion, and ad performance problems:",
    //         anchor: "Amazon Ads CTR Explained",
    //     },
    //     outbound: {
    //         top: [
    //             "howAmazonAdsForBooksWork",
    //             "amazonAdsKeywordStrategy",
    //             "howToImproveAmazonAdsConversion",
    //             "amazonAdsAcosExplained",
    //             "amazonAdsRoasExplained"
    //         ],
    //         bottom: [
    //             "amazonAdsForBooks",
    //             "howAmazonAdsForBooksWork",
    //             "amazonAdsForKdpBeginners",
    //             "amazonAdsTypesExplained",
    //             "amazonAdsLaunchStrategy",
    //             "amazonAdsKeywordStrategy",
    //             "amazonAdsForBookLaunch",
    //             "amazonAdsOptimizationStrategy",
    //             "howToLowerAcosAmazonAds",
    //             "howToImproveAmazonAdsConversion",
    //             "howToScaleAmazonAdsForBooks",
    //             "amazonAdsBudgetStrategy",
    //             "amazonAdsBiddingStrategy",
    //             "amazonAdsAcosExplained",
    //             "amazonAdsRoasExplained",
    //             "whyAmazonAdsNotWorking",
    //             "amazonAdsNoImpressions",
    //             "amazonAdsNoClicks",
    //             "amazonAdsHighAcosProblem"
    //         ]
    //     },
    // },
    // amazonAdsRoasExplained: {
    //     route: AMAZON_ADS_ROAS_EXPLAINED_ROUTE,
    //     labels: {
    //         top: "Explore pages that explain what ROAS means and how authors use it in Amazon Ads:",
    //         bottom: "Continue with related pages about ACOS, CTR, conversion, and ad performance problems:",
    //         anchor: "Amazon Ads ROAS Explained",
    //     },
    //     outbound: {
    //         top: [
    //             "amazonAdsAcosExplained",
    //             "howToImproveAmazonAdsConversion",
    //             "howToLowerAcosAmazonAds",
    //             "howToScaleAmazonAdsForBooks",
    //             "amazonAdsCtrExplained"
    //         ],
    //         bottom: [
    //             "amazonAdsForBooks",
    //             "howAmazonAdsForBooksWork",
    //             "amazonAdsForKdpBeginners",
    //             "amazonAdsTypesExplained",
    //             "amazonAdsLaunchStrategy",
    //             "amazonAdsKeywordStrategy",
    //             "amazonAdsForBookLaunch",
    //             "amazonAdsOptimizationStrategy",
    //             "howToLowerAcosAmazonAds",
    //             "howToImproveAmazonAdsConversion",
    //             "howToScaleAmazonAdsForBooks",
    //             "amazonAdsBudgetStrategy",
    //             "amazonAdsBiddingStrategy",
    //             "amazonAdsAcosExplained",
    //             "amazonAdsCtrExplained",
    //             "whyAmazonAdsNotWorking",
    //             "amazonAdsNoImpressions",
    //             "amazonAdsNoClicks",
    //             "amazonAdsHighAcosProblem"
    //         ]
    //     },
    // },
    // whyAmazonAdsNotWorking: {
    //     route: WHY_AMAZON_ADS_NOT_WORKING_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors diagnose why Amazon Ads are underperforming:",
    //         bottom: "Continue with related pages about impressions, clicks, ACOS, conversion, and ad optimization:",
    //         anchor: "Why Amazon Ads Not Working",
    //     },
    //     outbound: {
    //         top: [
    //             "amazonAdsOptimizationStrategy",
    //             "amazonAdsNoImpressions",
    //             "amazonAdsNoClicks",
    //             "amazonAdsHighAcosProblem",
    //             "howToImproveAmazonAdsConversion"
    //         ],
    //         bottom: [
    //             "amazonAdsForBooks",
    //             "howAmazonAdsForBooksWork",
    //             "amazonAdsForKdpBeginners",
    //             "amazonAdsTypesExplained",
    //             "amazonAdsLaunchStrategy",
    //             "amazonAdsKeywordStrategy",
    //             "amazonAdsForBookLaunch",
    //             "amazonAdsOptimizationStrategy",
    //             "howToLowerAcosAmazonAds",
    //             "howToImproveAmazonAdsConversion",
    //             "howToScaleAmazonAdsForBooks",
    //             "amazonAdsBudgetStrategy",
    //             "amazonAdsBiddingStrategy",
    //             "amazonAdsAcosExplained",
    //             "amazonAdsCtrExplained",
    //             "amazonAdsRoasExplained",
    //             "amazonAdsNoImpressions",
    //             "amazonAdsNoClicks",
    //             "amazonAdsHighAcosProblem"
    //         ]
    //     },
    // },
    // amazonAdsNoImpressions: {
    //     route: AMAZON_ADS_NO_IMPRESSIONS_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors diagnose why Amazon Ads are getting no impressions:",
    //         bottom: "Continue with related pages about clicks, ACOS, conversion, and ad optimization problems:",
    //         anchor: "Amazon Ads No Impressions",
    //     },
    //     outbound: {
    //         top: [
    //             "whyAmazonAdsNotWorking",
    //             "amazonAdsBiddingStrategy",
    //             "amazonAdsKeywordStrategy",
    //             "amazonAdsOptimizationStrategy",
    //             "amazonAdsForKdpBeginners"
    //         ],
    //         bottom: [
    //             "amazonAdsForBooks",
    //             "howAmazonAdsForBooksWork",
    //             "amazonAdsForKdpBeginners",
    //             "amazonAdsTypesExplained",
    //             "amazonAdsLaunchStrategy",
    //             "amazonAdsKeywordStrategy",
    //             "amazonAdsForBookLaunch",
    //             "amazonAdsOptimizationStrategy",
    //             "howToLowerAcosAmazonAds",
    //             "howToImproveAmazonAdsConversion",
    //             "howToScaleAmazonAdsForBooks",
    //             "amazonAdsBudgetStrategy",
    //             "amazonAdsBiddingStrategy",
    //             "amazonAdsAcosExplained",
    //             "amazonAdsCtrExplained",
    //             "amazonAdsRoasExplained",
    //             "whyAmazonAdsNotWorking",
    //             "amazonAdsNoClicks",
    //             "amazonAdsHighAcosProblem"
    //         ]
    //     },
    // },
    // amazonAdsNoClicks: {
    //     route: AMAZON_ADS_NO_CLICKS_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors diagnose why Amazon Ads are getting impressions but no clicks:",
    //         bottom: "Continue with related pages about CTR, conversion, ACOS, and ad optimization problems:",
    //         anchor: "Amazon Ads No Clicks",
    //     },
    //     outbound: {
    //         top: [
    //             "whyAmazonAdsNotWorking",
    //             "amazonAdsCtrExplained",
    //             "amazonAdsKeywordStrategy",
    //             "howToImproveAmazonAdsConversion",
    //             "amazonAdsNoImpressions"
    //         ],
    //         bottom: [
    //             "amazonAdsForBooks",
    //             "howAmazonAdsForBooksWork",
    //             "amazonAdsForKdpBeginners",
    //             "amazonAdsTypesExplained",
    //             "amazonAdsLaunchStrategy",
    //             "amazonAdsKeywordStrategy",
    //             "amazonAdsForBookLaunch",
    //             "amazonAdsOptimizationStrategy",
    //             "howToLowerAcosAmazonAds",
    //             "howToImproveAmazonAdsConversion",
    //             "howToScaleAmazonAdsForBooks",
    //             "amazonAdsBudgetStrategy",
    //             "amazonAdsBiddingStrategy",
    //             "amazonAdsAcosExplained",
    //             "amazonAdsCtrExplained",
    //             "amazonAdsRoasExplained",
    //             "whyAmazonAdsNotWorking",
    //             "amazonAdsNoImpressions",
    //             "amazonAdsHighAcosProblem"
    //         ]
    //     },
    // },
    // amazonAdsHighAcosProblem: {
    //     route: AMAZON_ADS_HIGH_ACOS_PROBLEM_ROUTE,
    //     labels: {
    //         top: "Explore pages that help authors diagnose why Amazon Ads have a high ACOS problem:",
    //         bottom: "Continue with related pages about ACOS, conversion, bidding, and ad optimization problems:",
    //         anchor: "Amazon Ads High ACOS Problem",
    //     },
    //     outbound: {
    //         top: [
    //             "whyAmazonAdsNotWorking",
    //             "howToLowerAcosAmazonAds",
    //             "amazonAdsAcosExplained",
    //             "howToImproveAmazonAdsConversion",
    //             "amazonAdsOptimizationStrategy"
    //         ],
    //         bottom: [
    //             "amazonAdsForBooks",
    //             "howAmazonAdsForBooksWork",
    //             "amazonAdsForKdpBeginners",
    //             "amazonAdsTypesExplained",
    //             "amazonAdsLaunchStrategy",
    //             "amazonAdsKeywordStrategy",
    //             "amazonAdsForBookLaunch",
    //             "amazonAdsOptimizationStrategy",
    //             "howToLowerAcosAmazonAds",
    //             "howToImproveAmazonAdsConversion",
    //             "howToScaleAmazonAdsForBooks",
    //             "amazonAdsBudgetStrategy",
    //             "amazonAdsBiddingStrategy",
    //             "amazonAdsAcosExplained",
    //             "amazonAdsCtrExplained",
    //             "amazonAdsRoasExplained",
    //             "whyAmazonAdsNotWorking",
    //             "amazonAdsNoImpressions",
    //             "amazonAdsNoClicks"
    //         ]
    //     },
    // },

    kdpEarnings: {
        route: KDP_EARNINGS_ROUTE,
        labels: {
            top: "Start with the most relevant earnings and KDP strategy pages:",
            bottom: "Continue with related Amazon publishing tools and guides:",
            anchor: "KDP Earnings",
        },
        outbound: {
            top: [
                "getAmazonBookReviews", "kdpToolsHub", "amazonBsrCalc",
                "kdpRoyaltyRates", "howAmazonBsrTranslatesToSales",
            ],
            bottom: ["freeAmazonBookReviews", "getAmazonBookReviews",
                "howMuchDoBooksSellOnAmazon",
                "howManyBooksDoYouNeedToSellToMakeMoney",
                "canYouMakeALivingWithKdp",
                "kdpIncomeCalculator",
                "selfPublishingRoiCalculator",
                "averageKdpIncome",
                "kdpIncomeExamples",
                "howMuchDoAuthorsMakeOnAmazon",
                "howMuchMoneyCanYouMakeOnKdp",
                "amazonSelfPublishingIncome",
                "amazonKdpRoyaltiesExplained",
            ],
        },
    },
    // howMuchDoAuthorsMakeOnAmazon: {
    //     route: HOW_MUCH_DO_AUTHORS_MAKE_ON_AMAZON_ROUTE,
    //     pageKey: "howMuchDoAuthorsMakeOnAmazon",
    //     textMode: "howMuchDoAuthorsMakeOnAmazon",
    //     labels: {
    //         top: "Start with the main KDP earnings hub and related income guides:",
    //         bottom: "Continue exploring Amazon publishing income, royalties, and sales estimates:",
    //         anchor: "How Much Do Authors Make on Amazon",
    //     },
    //     outbound: {
    //         top: ["kdpEarnings", "howMuchMoneyCanYouMakeOnKdp", "amazonSelfPublishingIncome"],
    //         bottom: ["kdpRoyaltyRates", "amazonKdpRoyaltiesExplained", "howAmazonBsrTranslatesToSales", "kdpIncomeCalculator", "kdpIncomeExamples"],
    //     },
    // },
    // howMuchMoneyCanYouMakeOnKdp: {
    //     route: HOW_MUCH_MONEY_CAN_YOU_MAKE_ON_KDP_ROUTE,
    //     pageKey: "howMuchMoneyCanYouMakeOnKdp",
    //     textMode: "howMuchMoneyCanYouMakeOnKdp",
    //
    //     labels: {
    //         top: "Start with the main KDP earnings hub and related income potential pages:",
    //         bottom: "Continue exploring Amazon publishing income, royalties, and calculator-style revenue pages:",
    //         anchor: "How Much Money Can You Make on KDP",
    //     },
    //
    //     outbound: {
    //         top: ["kdpEarnings", "howMuchDoAuthorsMakeOnAmazon", "amazonSelfPublishingIncome"],
    //         bottom: ["amazonKdpRoyaltiesExplained", "kdpRoyaltyRates", "kdpIncomeCalculator", "howAmazonBsrTranslatesToSales", "canYouMakeALivingWithKdp"],
    //     },
    //
    // },
    // amazonSelfPublishingIncome: {
    //     route: AMAZON_SELF_PUBLISHING_INCOME_ROUTE,
    //     pageKey: "amazonSelfPublishingIncome",
    //     textMode: "amazonSelfPublishingIncome",
    //
    //     labels: {
    //         top: "Start with the main KDP earnings hub and related self-publishing income pages:",
    //         bottom: "Continue exploring royalties, sales estimates, and long-term Amazon publishing revenue:",
    //         anchor: "Amazon Self Publishing Income",
    //     },
    //
    //     outbound: {
    //         top: ["kdpEarnings", "howMuchDoAuthorsMakeOnAmazon", "howMuchMoneyCanYouMakeOnKdp"],
    //         bottom: ["amazonKdpRoyaltiesExplained", "kdpRoyaltyRates", "howAmazonBsrTranslatesToSales", "kdpIncomeCalculator", "averageKdpIncome"],
    //     },
    //
    // },
    // amazonKdpRoyaltiesExplained: {
    //     route: AMAZON_KDP_ROYALTIES_EXPLAINED_ROUTE,
    //     pageKey: "amazonKdpRoyaltiesExplained",
    //     textMode: "amazonKdpRoyaltiesExplained",
    //
    //     labels: {
    //         top: "Start with the main KDP earnings hub and related royalty-focused pages:",
    //         bottom: "Continue exploring royalty rates, calculators, and income potential across Amazon KDP:",
    //         anchor: "Amazon KDP Royalties Explained",
    //     },
    //
    //     outbound: {
    //         top: ["kdpEarnings", "kdpRoyaltyRates", "amazonKdpRoyaltyCalculator"],
    //         bottom: ["howMuchDoAuthorsMakeOnAmazon", "howMuchMoneyCanYouMakeOnKdp", "amazonSelfPublishingIncome", "kdpIncomeCalculator", "howAmazonBsrTranslatesToSales"],
    //     },
    //
    // },
    // kdpRoyaltyRates: {
    //     route: KDP_ROYALTY_RATES_ROUTE,
    //     pageKey: "kdpRoyaltyRates",
    //     textMode: "kdpRoyaltyRates",
    //     labels: {
    //         top: "Start with the most relevant KDP royalties and earnings pages:",
    //         bottom: "Continue exploring related Amazon publishing income tools:",
    //         anchor: "KDP Royalty Rates",
    //     },
    //     outbound: {
    //         top: ["kdpEarnings", "amazonKdpRoyaltiesExplained", "amazonKdpRoyaltyCalculator"],
    //         bottom: ["kdpIncomeCalculator", "howAmazonBsrTranslatesToSales", "canYouMakeALivingWithKdp", "freeToolsForAuthors"],
    //     },
    // },
    // amazonKdpRoyaltyCalculator: {
    //     route: AMAZON_KDP_ROYALTY_CALCULATOR_ROUTE,
    //     pageKey: "amazonKdpRoyaltyCalculator",
    //     textMode: "amazonKdpRoyaltyCalculator",
    //
    //     labels: {
    //         top: "Start with the main KDP earnings hub and related royalty calculator pages:",
    //         bottom: "Continue exploring royalty rules, print cost logic, and income estimation across Amazon KDP:",
    //         anchor: "Amazon KDP Royalty Calculator",
    //     },
    //
    //     outbound: {
    //         top: ["kdpEarnings", "amazonKdpRoyaltiesExplained", "kdpRoyaltyRates"],
    //         bottom: ["kdpIncomeCalculator", "howAmazonBsrTranslatesToSales", "amazonSelfPublishingIncome", "howMuchMoneyCanYouMakeOnKdp", "howMuchDoAuthorsMakeOnAmazon"],
    //     },
    //
    // },
    // howAmazonBsrTranslatesToSales: {
    //     route: HOW_AMAZON_BSR_TRANSLATES_TO_SALES_ROUTE,
    //     pageKey: "howAmazonBsrTranslatesToSales",
    //     textMode: "howAmazonBsrTranslatesToSales",
    //
    //     labels: {
    //         top: "Start with the main KDP earnings hub and related BSR and sales estimate pages:",
    //         bottom: "Continue exploring royalties, income calculators, and realistic sales-to-revenue planning:",
    //         anchor: "How Amazon BSR Translates to Sales",
    //     },
    //
    //     outbound: {
    //         top: ["kdpEarnings", "amazonKdpRoyaltyCalculator", "howMuchDoAuthorsMakeOnAmazon"],
    //         bottom: ["amazonKdpRoyaltiesExplained", "kdpIncomeCalculator", "howMuchMoneyCanYouMakeOnKdp", "amazonSelfPublishingIncome", "kdpRoyaltyRates"],
    //     },
    //
    // },
    // howMuchDoBooksSellOnAmazon: {
    //     route: HOW_MUCH_DO_BOOKS_SELL_ON_AMAZON_ROUTE,
    //     pageKey: "howMuchDoBooksSellOnAmazon",
    //     textMode: "howMuchDoBooksSellOnAmazon",
    //
    //     labels: {
    //         top: "Start with the main KDP earnings hub and related sales estimate pages:",
    //         bottom: "Continue exploring BSR-to-sales logic, royalties, and income planning for Amazon books:",
    //         anchor: "How Much Do Books Sell on Amazon",
    //     },
    //
    //     outbound: {
    //         top: ["kdpEarnings", "howAmazonBsrTranslatesToSales", "howMuchDoAuthorsMakeOnAmazon"],
    //         bottom: ["howMuchMoneyCanYouMakeOnKdp", "amazonKdpRoyaltyCalculator", "amazonKdpRoyaltiesExplained", "kdpIncomeCalculator", "amazonSelfPublishingIncome"],
    //     },
    //
    // },
    // howManyBooksDoYouNeedToSellToMakeMoney: {
    //     route: HOW_MANY_BOOKS_DO_YOU_NEED_TO_SELL_TO_MAKE_MONEY_ROUTE,
    //     pageKey: "howManyBooksDoYouNeedToSellToMakeMoney",
    //     textMode: "howManyBooksDoYouNeedToSellToMakeMoney",
    //
    //     labels: {
    //         top: "Start with the main KDP earnings hub and related income-goal pages:",
    //         bottom: "Continue exploring royalties, sales estimates, and practical income planning for Amazon KDP:",
    //         anchor: "How Many Books Do You Need to Sell to Make Money",
    //     },
    //
    //     outbound: {
    //         top: ["kdpEarnings", "howMuchMoneyCanYouMakeOnKdp", "howAmazonBsrTranslatesToSales"],
    //         bottom: ["kdpIncomeCalculator", "amazonKdpRoyaltyCalculator", "amazonKdpRoyaltiesExplained", "howMuchDoBooksSellOnAmazon", "canYouMakeALivingWithKdp"],
    //     },
    //
    // },
    // canYouMakeALivingWithKdp: {
    //     route: CAN_YOU_MAKE_A_LIVING_WITH_KDP_ROUTE,
    //     pageKey: "canYouMakeALivingWithKdp",
    //     textMode: "canYouMakeALivingWithKdp",
    //
    //     labels: {
    //         top: "Start with the main KDP earnings hub and related full-time income pages:",
    //         bottom: "Continue exploring income potential, sales goals, royalties, and realistic Amazon publishing revenue:",
    //         anchor: "Can You Make a Living With KDP",
    //     },
    //
    //     outbound: {
    //         top: ["kdpEarnings", "howMuchMoneyCanYouMakeOnKdp", "howManyBooksDoYouNeedToSellToMakeMoney"],
    //         bottom: ["howMuchDoAuthorsMakeOnAmazon", "amazonSelfPublishingIncome", "kdpIncomeCalculator", "howAmazonBsrTranslatesToSales", "averageKdpIncome"],
    //     },
    //
    // },
    // kdpIncomeCalculator: {
    //     route: KDP_INCOME_CALCULATOR_ROUTE,
    //     pageKey: "kdpIncomeCalculator",
    //     textMode: "kdpIncomeCalculator",
    //
    //     labels: {
    //         top: "Start with the main KDP earnings hub and related calculator-style income pages:",
    //         bottom: "Continue exploring royalties, sales estimates, and realistic Amazon publishing revenue planning:",
    //         anchor: "KDP Income Calculator",
    //     },
    //
    //     outbound: {
    //         top: ["kdpEarnings", "amazonKdpRoyaltyCalculator", "howManyBooksDoYouNeedToSellToMakeMoney"],
    //         bottom: ["howAmazonBsrTranslatesToSales", "amazonKdpRoyaltiesExplained", "howMuchMoneyCanYouMakeOnKdp", "canYouMakeALivingWithKdp", "amazonSelfPublishingIncome"],
    //     },
    //
    // },
    // selfPublishingRoiCalculator: {
    //     route: SELF_PUBLISHING_ROI_CALCULATOR_ROUTE,
    //     pageKey: "selfPublishingRoiCalculator",
    //     textMode: "selfPublishingRoiCalculator",
    //
    //     labels: {
    //         top: "Start with the main KDP earnings hub and related ROI and calculator-focused pages:",
    //         bottom: "Continue exploring royalties, income estimates, and realistic profitability planning for self-published books:",
    //         anchor: "Self Publishing ROI Calculator",
    //     },
    //
    //     outbound: {
    //         top: ["kdpEarnings", "kdpIncomeCalculator", "amazonKdpRoyaltyCalculator"],
    //         bottom: ["amazonKdpRoyaltiesExplained", "howManyBooksDoYouNeedToSellToMakeMoney", "howMuchMoneyCanYouMakeOnKdp", "canYouMakeALivingWithKdp", "amazonSelfPublishingIncome"],
    //     },
    //
    // },
    // averageKdpIncome: {
    //     route: AVERAGE_KDP_INCOME_ROUTE,
    //     pageKey: "averageKdpIncome",
    //     textMode: "averageKdpIncome",
    //
    //     labels: {
    //         top: "Start with the main KDP earnings hub and related expectation-focused income pages:",
    //         bottom: "Continue exploring author earnings, royalties, and realistic Amazon publishing benchmarks:",
    //         anchor: "Average KDP Income",
    //     },
    //
    //     outbound: {
    //         top: ["kdpEarnings", "howMuchDoAuthorsMakeOnAmazon", "canYouMakeALivingWithKdp"],
    //         bottom: ["howMuchMoneyCanYouMakeOnKdp", "amazonSelfPublishingIncome", "kdpIncomeExamples", "kdpIncomeCalculator", "howAmazonBsrTranslatesToSales"],
    //     },
    //
    // },
    // kdpIncomeExamples: {
    //     route: KDP_INCOME_EXAMPLES_ROUTE,
    //     pageKey: "kdpIncomeExamples",
    //     textMode: "kdpIncomeExamples",
    //
    //     labels: {
    //         top: "Start with the main KDP earnings hub and related example-based income pages:",
    //         bottom: "Continue exploring average earnings, income potential, royalties, and realistic Amazon publishing benchmarks:",
    //         anchor: "KDP Income Examples",
    //     },
    //
    //     outbound: {
    //         top: ["kdpEarnings", "averageKdpIncome", "howMuchDoAuthorsMakeOnAmazon"],
    //         bottom: ["howMuchMoneyCanYouMakeOnKdp", "canYouMakeALivingWithKdp", "amazonSelfPublishingIncome", "kdpIncomeCalculator", "howAmazonBsrTranslatesToSales"],
    //     },
    //
    // },

    // kdpRisksAndBans: {
    //     route: KDP_RISKS_AND_BANS_ROUTE,
    //     labels: {
    //         top: "Explore pages that explain the main KDP account risks, bans, and safer publishing practices:",
    //         bottom: "Continue with related pages about review safety, copyright risk, and policy-sensitive Amazon behaviors:",
    //         anchor: "KDP Risks and Bans",
    //     },
    //     outbound: {
    //         top: [
    //             "banForCopyrightViolation",
    //             "banForFakeReviews",
    //             "howToGetAmazonReviewsSafely"
    //         ],
    //         bottom: [
    //             "banForCopyrightViolation",
    //             "banForFakeReviews",
    //             "howToGetAmazonReviewsSafely"
    //         ]
    //     },
    // },
    // banForCopyrightViolation: {
    //     route: BAN_FOR_COPYRIGHT_VIOLATION_ROUTE,
    //     labels: {
    //         top: "Explore pages that explain copyright-related KDP ban risk and safer publishing practices:",
    //         bottom: "Continue with related pages about review safety, account risk, and policy-sensitive Amazon behaviors:",
    //         anchor: "Ban for Copyright Violation",
    //     },
    //     outbound: {
    //         top: [
    //             "kdpRisksAndBans",
    //             "banForFakeReviews",
    //             "howToGetAmazonReviewsSafely"
    //         ],
    //         bottom: [
    //             "kdpRisksAndBans",
    //             "banForFakeReviews",
    //             "howToGetAmazonReviewsSafely"
    //         ]
    //     },
    // },
    // banForFakeReviews: {
    //     route: BAN_FOR_FAKE_REVIEWS_ROUTE,
    //     labels: {
    //         top: "Explore pages that explain fake-review risk, review safety, and safer Amazon publishing practices:",
    //         bottom: "Continue with related pages about copyright risk, review safety, and policy-sensitive Amazon behaviors:",
    //         anchor: "Ban for Fake Reviews",
    //     },
    //     outbound: {
    //         top: [
    //             "kdpRisksAndBans",
    //             "banForCopyrightViolation",
    //             "howToGetAmazonReviewsSafely"
    //         ],
    //         bottom: [
    //             "kdpRisksAndBans",
    //             "banForCopyrightViolation",
    //             "howToGetAmazonReviewsSafely"
    //         ]
    //     },
    // },
    // howToGetAmazonReviewsSafely: {
    //     route: HOW_TO_GET_AMAZON_REVIEWS_SAFELY_ROUTE,
    //     labels: {
    //         top: "Explore pages that explain safer Amazon review strategy and long-term account protection:",
    //         bottom: "Continue with related pages about fake-review risk, copyright risk, and safer KDP publishing practices:",
    //         anchor: "How to Get Amazon Reviews Safely",
    //     },
    //     outbound: {
    //         top: [
    //             "kdpRisksAndBans",
    //             "banForFakeReviews",
    //             "banForCopyrightViolation"
    //         ],
    //         bottom: [
    //             "kdpRisksAndBans",
    //             "banForFakeReviews",
    //             "banForCopyrightViolation"
    //         ]
    //     },
    // },

};

export const getPageConfig = (pageKey) => PAGE_REGISTRY?.[pageKey] || null;

export const getPageRoute = (pageKey) => getPageConfig(pageKey)?.route || "";

export const getPageAnchor = (pageKey) =>
    getPageConfig(pageKey)?.labels?.anchor || pageKey;

export const getPageLabel = (pageKey, placement = "top") =>
    getPageConfig(pageKey)?.labels?.[placement] || "";

export const getPageOutboundIds = (pageKey, placement = "top") =>
    getPageConfig(pageKey)?.outbound?.[placement] || [];
